// // src/pages/DriverTrip.jsx
// import React, { useState, useEffect, useRef } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { defaultUserImg } from "../assets/defaultUser";
// import {
//   MapContainer,
//   TileLayer,
//   Marker,
//   Popup,
//   Polyline,
//   useMap,
// } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import L from "leaflet";

// // Import vehicle icons
// import carIcon from "../assets/car.png";
// import vanIcon from "../assets/van.png";
// import busIcon from "../assets/bus.png";
// import lorryIcon from "../assets/lorry.png";
// import suvIcon from "../assets/suv.png";
// import cabIcon from "../assets/cab.png";
// import forkliftIcon from "../assets/fork lift.png";
// import dockyardIcon from "../assets/dockyard.png";
// import cherryIcon from "../assets/cherry.png";
// import craneIcon from "../assets/crane.jpg";
// import DriverHeader from "../components/DriverHeader";
// import DriverFooter from "../components/DriverFooter";
// import CallEmployeeButton from "../components/CallEmployeeButton";
// import HireAssistanceBubble from "../components/HireAssistanceBubble";
// import { useDispatch, useSelector } from "react-redux";
// import api from "../services/api";
// import { calculateDistance, estimateETA, calculateFare } from "../services/mapsService";
// import locationWS from "../services/locationWebSocket";
// import trackingWS from "../services/trackingWebSocket";
// import bookingWS from "../services/bookingWebSocket";  // 🔴 NEW
// import chatWS from "../services/chatWebSocket"; // NEW
// import EmergencyAlertModal from "../components/EmergencyAlertModal"; // NEW
// import { updateEmergency } from "../services/vehicleService"; // NEW
// import { fetchBookings } from "../actions/BookingActions";
// import { getForkBookingDetails, postForkBookingForDriver,PostRequestedstatus } from "../services/bookingService";
// import { fetchUsers } from "../actions/UserActions";
// import { fetchVehicles } from "../actions/VehicleActions";

// // Fix Leaflet icon
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
//   iconUrl: require("leaflet/dist/images/marker-icon.png"),
//   shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
// });

// // Helper to validate and parse coordinates
// const parseCoordinate = (value) => {
//   const parsed = parseFloat(value);
//   return !isNaN(parsed) ? parsed : null;
// };

// // Helper to ensure valid LatLng array
// const ensureValidLatLng = (lat, lng) => {
//   const validLat = parseCoordinate(lat);
//   const validLng = parseCoordinate(lng);
//   if (validLat !== null && validLng !== null) {
//     return [validLat, validLng];
//   }
//   return null;
// };

// // Function to get vehicle icon based on type (supports both codes and full names)
// const getVehicleIcon = (vehicleType) => {
//   const type = vehicleType?.toUpperCase()?.trim() || "C";
//   let iconUrl = carIcon;
  
//   // Match by code first, then by name
//   if (type === "V" || type.includes("VAN")) iconUrl = vanIcon;
//   else if (type === "B" || type.includes("BUS")) iconUrl = busIcon;
//   else if (type === "L" || type.includes("LORRY") || type.includes("TRUCK")) iconUrl = lorryIcon;
//   else if (type === "S" || type.includes("SUV")) iconUrl = suvIcon;
//   else if (type === "CA" || type.includes("CAB") || type.includes("TAXI")) iconUrl = cabIcon;
//   else if (type === "F" || type.includes("FORKLIFT") || type.includes("FORK")) iconUrl = forkliftIcon;
//   else if (type.includes("DOCKYARD")) iconUrl = dockyardIcon;
//   else if (type === "CH" || type.includes("CHERRY")) iconUrl = cherryIcon;
//   else if (type === "CR" || type.includes("CRANE")) iconUrl = craneIcon;
//   else if (type === "C" || type.includes("CAR")) iconUrl = carIcon;
  
//   return new L.Icon({
//     iconUrl: iconUrl,
//     iconSize: [45, 45],
//     iconAnchor: [22, 45],
//     popupAnchor: [0, -45],
//   });
// };

// const pickupIcon = new L.Icon({
//   iconUrl: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
//   iconSize: [40, 40],
//   iconAnchor: [20, 40],
//   popupAnchor: [0, -40],
// });

// const destinationIcon = new L.Icon({
//   iconUrl: "https://cdn-icons-png.flaticon.com/512/149/149060.png",
//   iconSize: [40, 40],
//   iconAnchor: [20, 40],
//   popupAnchor: [0, -40],
// });

// // Map auto-fit to show all points (only once initially)
// const FitBounds = ({ bounds }) => {
//   const map = useMap();
//   const hasFitted = useRef(false);

//   useEffect(() => {
//     if (bounds && bounds.length >= 2 && !hasFitted.current) {
//       map.fitBounds(bounds, { padding: [50, 50], maxZoom: 15 });
//       hasFitted.current = true; // Only fit once
//     }
//   }, [bounds, map]);
//   return null;
// };

// // Fetch route from OpenRouteService
// const fetchRoute = async (start, end) => {
//   const apiKey = process.env.REACT_APP_ORS_KEY;
//   if (!apiKey) return null;
//   try {
//     const url = `https://api.openrouteservice.org/v2/directions/driving-car?api_key=${apiKey}&start=${start[1]},${start[0]}&end=${end[1]},${end[0]}`;
//     const res = await fetch(url);
//     const data = await res.json();
//     const coords = data.features?.[0]?.geometry?.coordinates;
//     if (coords) {
//       return coords.map(([lng, lat]) => [lat, lng]);
//     }
//   } catch (e) {
//     console.error("Route fetch error:", e);
//   }
//   return null;
// };

// const DriverTrip = () => {
//   const dispatch = useDispatch();
//   const getBookings = async () => dispatch(fetchBookings());
//   const getUsers = async () => dispatch(fetchUsers());
//   const getVehicles = async () => dispatch(fetchVehicles());
//   const { authKey, userDetails } = useSelector((state) => state.auth);
//   const { bookingId } = useParams();
//   const navigate = useNavigate();

//   // 🔴 REMOVED: No longer using location.state - always fetch fresh from API
//   // This ensures refresh works and status is always up-to-date

//   // Determine initial trip stage based on booking status - SINGLE SOURCE OF TRUTH
//   const determineInitialTripStage = (bookingData) => {
//     console.log("[DriverTrip] determineInitialTripStage called with:", bookingData);
    
//     if (!bookingData) {
//       console.log("[DriverTrip] No booking data, returning 'accepted'");
//       return "accepted";
//     }
    
//     const status = bookingData.status?.toUpperCase()?.trim() || "";
//     console.log("[DriverTrip] determineInitialTripStage - booking.status raw:", bookingData.status);
//     console.log("[DriverTrip] determineInitialTripStage - booking status (uppercase, trimmed):", status);
    
//     if (status === "A" || status === "ACTIVE") {
//       console.log("[DriverTrip] Status is A/ACTIVE → returning 'accepted'");
//       return "accepted";
//     } else if (status === "EN" || status === "ENROUTE") {
//       console.log("[DriverTrip] Status is EN/ENROUTE → returning 'heading_to_pickup'");
//       return "heading_to_pickup";
//     } else if (status === "IP" || status === "INPROGRESS" || status === "IN PROGRESS") {
//       console.log("[DriverTrip] Status is IP/INPROGRESS/IN PROGRESS → returning 'trip_started'");
//       return "trip_started";
//     }
    
//     console.log("[DriverTrip] Status not matched, defaulting to 'accepted'");
//     return "accepted";
//   };

//   // 🔴 NEW: Loading and error states
//   const [isLoading, setIsLoading] = useState(true);
//   const [loadError, setLoadError] = useState(null);

//   const [booking, setBooking] = useState(null);
//   const [vehicleType, setVehicleType] = useState("C"); // Vehicle type for map icon
//   // Stages: accepted → heading_to_pickup → arrived_at_pickup → trip_started → completed
//   const [tripStage, setTripStage] = useState("accepted");

//   const getLatestBookingById = async (id) => {
//     const allBookings = await getBookings();
//     const found = allBookings.find((b) => b.bId?.toString() === id?.toString()) || null;
//     if (found && (found.bsTime || found.beTime)) return found;

//     try {
//       const forkDetails = await getForkBookingDetails(id);
//       if (Array.isArray(forkDetails) && forkDetails[0]) {
//         return { ...found, ...forkDetails[0] };
//       }
//       if (forkDetails && typeof forkDetails === "object") {
//         return { ...found, ...forkDetails };
//       }
//     } catch (err) {
//       console.warn("[DriverTrip] Failed to load fork booking details for status normalization:", err);
//     }

//     return found;
//   };

//   const getVehicleById = async (id) => {
//     const vehicles = await getVehicles();
//     return vehicles.find((v) => v.vehicleId?.toString() === id?.toString()) || null;
//   };

//   const getEmployeeByServiceNo = async (serviceNo) => {
//     const users = await getUsers();
//     return users.find((u) => u.ServiceNo?.toString() === serviceNo?.toString()) || null;
//   };
//   const [driverLocation, setDriverLocation] = useState(null);
//   const [routeToPickup, setRouteToPickup] = useState([]);
//   const [routeToDestination, setRouteToDestination] = useState([]);
//   const [distanceToPickup, setDistanceToPickup] = useState(null);
//   const [distanceToDestination, setDistanceToDestination] = useState(null);
//   const [employeePhoneNumber, setEmployeePhoneNumber] = useState(null);
//   const [activeHire, setActiveHire] = useState(null);
//   const [hireStage, setHireStage] = useState('accepted');
//   const [isEmergencyModalOpen, setIsEmergencyModalOpen] = useState(false); // NEW
//   const [isSendingEmergency, setIsSendingEmergency] = useState(false); // NEW
//   const lastRouteRefresh = useRef(0);

//   const locationInterval = useRef(null);

//   const resolveSubBookingForVehicle = (bookingData) => {
//     if (!bookingData) return null;
//     const subBookings =
//       bookingData.SubBookings ||
//       bookingData.subBookings ||
//       bookingData.subBooking ||
//       bookingData.subBookingDetails ||
//       [];
//     if (!Array.isArray(subBookings) || subBookings.length === 0) return null;
//     const vId = String(bookingData?.vId || "");
//     return (
//       subBookings.find((sub) => String(sub?.subvid || sub?.subvId || sub?.vId || sub?.vid || "") === vId) ||
//       null
//     );
//   };

//   const getDisplayLocations = (bookingData) => {
//     if (!bookingData) return { from: "", to: "" };
//     const baseFrom = bookingData.From || bookingData.fromLocation || bookingData.WorkArea || "";
//     const baseTo = bookingData.TO || bookingData.toLocation || "";
//     if (baseFrom || baseTo) return { from: baseFrom, to: baseTo };
//     const sub = resolveSubBookingForVehicle(bookingData);
//     if (!sub) return { from: "", to: "" };
//     const subFrom = sub.subFrom || sub.From || sub.from || "";
//     const subTo = sub.subTO || sub.TO || sub.to || "";
//     return { from: subFrom || "", to: subTo || "" };
//   };

//   // Handle Emergency Alert
//   const handleOpenEmergency = () => {
//     setIsEmergencyModalOpen(true);
//   };

//   const handleSendEmergency = async ({ ecode, ediscription }) => {
//     if (!booking?.vId) {
//       toast.error("No vehicle assigned. Cannot send alert.");
//       return;
//     }

//     setIsSendingEmergency(true);
//     try {
//       // 1. Update Backend (Database)
//       await updateEmergency(booking.vId, ecode, ediscription);
      
//       // 2. Notify Admins via WebSocket (Real-time)
//       const success = chatWS.sendEmergency({
//         vehicleId: booking.vId,
//         ecode: ecode,
//         ediscription: ediscription,
//         driverName: userDetails?.Name || "Driver",
//         driverSno: userDetails?.ServiceNo || "",
//         mobileNo: "N/A" // Mobile not available in this context
//       });

//       if (!success) {
//         console.warn("WebSocket send failed for emergency, but DB updated.");
//       }

//       toast.success("EMERGENCY ALERT SENT! Help is on the way.");
//       setIsEmergencyModalOpen(false);
//     } catch (error) {
//       console.error("Emergency Alert Failed:", error);
//       toast.error("Failed to send alert! Please call emergency services.");
//     } finally {
//       setIsSendingEmergency(false);
//     }
//   };

//   // Get current location
//   const getCurrentLocation = () => {
//     return new Promise((resolve) => {
//       if ("geolocation" in navigator) {
//         navigator.geolocation.getCurrentPosition(
//           (pos) => {
//             resolve({
//               latitude: parseFloat(pos.coords.latitude.toFixed(6)),
//               longitude: parseFloat(pos.coords.longitude.toFixed(6)),
//             });
//           },
//           () => resolve(driverLocation),
//           { enableHighAccuracy: true, timeout: 10000 }
//         );
//       } else {
//         resolve(driverLocation);
//       }
//     });
//   };

//   // Calculate distance between two points (km)
//   const haversineDistance = (lat1, lon1, lat2, lon2) => {
//     const R = 6371;
//     const dLat = (lat2 - lat1) * Math.PI / 180;
//     const dLon = (lon2 - lon1) * Math.PI / 180;
//     const a = Math.sin(dLat/2) ** 2 + Math.cos(lat1 * Math.PI/180) * Math.cos(lat2 * Math.PI/180) * Math.sin(dLon/2) ** 2;
//     return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//   };

//   // Initialize hire bubble with booking data
//   const initializeHireBubble = (bookingData) => {
//     if (!bookingData) return;

//     const pickup = ensureValidLatLng(bookingData.slatitude, bookingData.slongitude);
//     const destination = ensureValidLatLng(bookingData.elatitude, bookingData.elongitude);

//     if (!pickup || !destination) {
//       console.warn("[DriverTrip] Invalid coordinates for hire bubble:", {
//         pickup: bookingData.slatitude,
//         destination: bookingData.elatitude,
//       });
//       return;
//     }

//     const distance = calculateDistance(
//       { lat: pickup[0], lng: pickup[1] },
//       { lat: destination[0], lng: destination[1] }
//     );
//     const eta = estimateETA(distance);
//     const fare = calculateFare(distance);

//     setActiveHire({
//       hireId: bookingData.bId,
//       bookingId: bookingData.bId,
//       status: tripStage,
//       pickupLocation: { lat: pickup[0], lng: pickup[1] },
//       destinationLocation: { lat: destination[0], lng: destination[1] },
//       distance: distance,
//       eta: eta,
//       fare: fare,
//     });

//     setHireStage(tripStage);
//   };

//   const normalizeBookingStatusCode = (bookingOrValue) => {
//     const raw = bookingOrValue?.BookingStatus ?? bookingOrValue;
//     const normalized = String(raw || "").trim().toUpperCase();
//     const hasScheduleTimes = Boolean(bookingOrValue?.bsTime && bookingOrValue?.beTime);
//     const isScheduledLabel =
//       normalized === "S" || normalized === "SHEDULE BOOKING" || normalized === "SCHEDULE BOOKING";
//     const isRealtimeLabel =
//       normalized === "R" || normalized === "REAL-TIME BOOKING" || normalized === "REAL TIME BOOKING";

//     if (isScheduledLabel) return "S";
//     if (hasScheduleTimes) return "S";
//     return "R";
//   };

//   // Update driver location and send to WebSocket
//   const updateDriverLocation = async () => {
//     const loc = await getCurrentLocation();
//     if (!loc) return;
    
//     setDriverLocation(loc);

//     // Calculate distances
//     if (booking) {
//       const pickup = ensureValidLatLng(booking.slatitude, booking.slongitude);
//       const dest = ensureValidLatLng(booking.elatitude, booking.elongitude);
      
//       if (pickup) {
//         setDistanceToPickup(haversineDistance(loc.latitude, loc.longitude, pickup[0], pickup[1]).toFixed(1));
//       }
//       if (dest) {
//         setDistanceToDestination(haversineDistance(loc.latitude, loc.longitude, dest[0], dest[1]).toFixed(2));
//       }
//     }

//     // Update vehicle in DB and WebSocket - ONLY update location
//     if (booking?.vId) {
//       try {
//         const payload = [{
//           vehicleId: booking.vId,
//           status: "A",
//           latitude: loc.latitude,
//           longitude: loc.longitude,
//         }];
//         await api.post("/VehicleRegister/UpdateVehicleLocation", payload);
        
//         // Send location via WebSocket for live tracking
//         if (locationWS.isReady()) {
//           locationWS.updateDriverData({
//             latitude: loc.latitude,
//             longitude: loc.longitude,
//             bStatus: "B",
//           });
//         }
//       } catch (err) {
//         console.error("Location update failed", err);
//       }
//     }
//   };

//   // Clear bStatus after trip completion so vehicle reappears on maps (use full payload shape)
//   const resetVehicleBStatus = async () => {
//     if (!booking?.vId) return;

//     const loc = await getCurrentLocation();
//     let vehicle = null;

//     try {
//       vehicle = await getVehicleById(booking.vId);
//     } catch (err) {
//       console.error("Failed to fetch vehicle before reset bStatus:", err.response?.data || err.message);
//     }

//     // Build payload similar to updateVehicleInDB/updateVehicleBookingStatus for consistency
//     const typeCodeMap = {
//       Car: "C", Van: "V", Lorry: "L", SUV: "S", Cab: "CA",
//       Bus: "B", "Cherry Picker": "CH", Forklift: "F", Crane: "CR", Trailer: "T",
//     };
//     const vehicleTypeCode = typeCodeMap[vehicle?.vehicleType] || vehicle?.vehicleType || "C";
//     const statusCode = vehicle?.status === "Inactive" ? "I" : vehicle?.status === "Active" ? "A" : "A";
//     const oStatusValue = "O"; // keep online so it shows immediately

//     const payload = [{
//       vehicleId: vehicle?.vehicleId || booking.vId,
//       vehicleType: vehicleTypeCode,
//       weightCat: vehicle?.weightCat || "",
//       driverSno: vehicle?.driverSno || userDetails?.ServiceNo || "",
//       status: statusCode,
//       bStatus: "", // make vehicle available
//       oStatus: oStatusValue,
//       latitude: loc?.latitude ?? vehicle?.latitude ?? "",
//       longitude: loc?.longitude ?? vehicle?.longitude ?? "",
//     }];

//     try {
//       await api.post("/VehicleRegister/PostVehicleDetails", payload);
//       console.log("Reset bStatus to empty for vehicle", booking.vId);

//       // Push real-time update so map reappears immediately with correct vehicle type
//       locationWS.updateDriverData({
//         vehicleId: vehicle?.vehicleId || booking.vId,
//         vehicle_type: vehicle?.vehicleType || "Car", // Full name for icon
//         vehicleType: vehicle?.vehicleType || "Car",
//         latitude: payload[0].latitude,
//         longitude: payload[0].longitude,
//         bStatus: "",
//         oStatus: "O",
//         status: statusCode,
//       });
//       if (locationWS.isReady()) {
//         locationWS.sendLocationUpdate();
//       }
//     } catch (err) {
//       console.error("Failed to reset vehicle bStatus:", err.response?.data || err.message);
//     }
//   };

//   // Fetch routes
//   const loadRoutes = async () => {
//     if (!booking || !driverLocation) return;

//     const pickup = ensureValidLatLng(booking.slatitude, booking.slongitude);
//     const dest = ensureValidLatLng(booking.elatitude, booking.elongitude);

//     if (!pickup || !dest) {
//       console.warn("[DriverTrip] Cannot load routes - invalid coordinates");
//       return;
//     }

//     const driver = [driverLocation.latitude, driverLocation.longitude];

//     // Route from driver to pickup
//     const toPickup = await fetchRoute(driver, pickup);
//     if (toPickup) setRouteToPickup(toPickup);

//     // Route from pickup to destination
//     const toDest = await fetchRoute(pickup, dest);
//     if (toDest) setRouteToDestination(toDest);
//   };

//   // Recompute routes when driver moves (throttled to avoid spam)
//   useEffect(() => {
//     const now = Date.now();
//     if (!booking || !driverLocation) return;
//     if (now - lastRouteRefresh.current < 30000) return; // throttle 30s
//     lastRouteRefresh.current = now;
//     loadRoutes();
//   }, [driverLocation?.latitude, driverLocation?.longitude, booking, tripStage]);

//   // Fetch employee phone number using their ServiceNo
//   const fetchEmployeePhoneNumber = async (employeeServiceNo) => {
//     if (!employeeServiceNo) {
//       console.log("No employee service number provided");
//       setEmployeePhoneNumber(null);
//       return;
//     }

//     try {
//       const employee = await getEmployeeByServiceNo(employeeServiceNo);
//       if (employee && employee.MobileNo) {
//         console.log("Setting phone number:", employee.MobileNo);
//         setEmployeePhoneNumber(employee.MobileNo);
//       } else {
//         console.log("No mobile number found for employee");
//         setEmployeePhoneNumber(null);
//       }
//     } catch (err) {
//       console.error("Failed to fetch employee phone number:", err);
//       setEmployeePhoneNumber(null);
//     }
//   };

//   // Stage Actions
//   const handleStartToPickup = async () => {
//     try {
//       if (!booking?.bId) {
//         toast.error("No booking loaded");
//         return;
//       }

//       // Update booking status to EN (EnRoute) via API (status-only to avoid overwrite)
//       const updatedBooking = {
//         ...booking,
//         status: "EN", // En Route to pickup
//       };

//       const payload = [
//         {
//           bId: String(booking.bId),
//           status: "EN",
//         },
//       ];
//       await postForkBookingForDriver(payload);

//       // Send WebSocket update
//       bookingWS.sendStatusUpdate({
//         bId: booking.bId,
//         status: "EN",
//         dlatitude: driverLocation?.latitude,
//         dlongitude: driverLocation?.longitude,
//         vId: booking.vId,
//         dSNo: userDetails?.ServiceNo,
//       });

//       // Update local state
//       setBooking(updatedBooking);
//       setTripStage("heading_to_pickup");
//       initializeHireBubble(updatedBooking);
      
//       toast.success("✅ Heading to pickup location");
//     } catch (err) {
//       console.error("[DriverTrip] Failed to start trip to pickup:", err);
//       toast.error("Failed to update status. Please try again.");
//     }
//   };

//   const handleArrivedAtPickup = async () => {
//     try {
//       if (!booking?.bId) {
//         toast.error("No booking loaded");
//         return;
//       }

//       // Update booking status to IP (InProgress) via API (status-only to avoid overwrite)
//       const updatedBooking = {
//         ...booking,
//         status: "IP", // In Progress - started trip
//       };

//       const payload = [
//         {
//           bId: String(booking.bId),
//           status: "IP",
//         },
//       ];
//       await postForkBookingForDriver(payload);

//       // Send WebSocket update
//       bookingWS.sendStatusUpdate({
//         bId: booking.bId,
//         status: "IP",
//         dlatitude: driverLocation?.latitude,
//         dlongitude: driverLocation?.longitude,
//         vId: booking.vId,
//         dSNo: userDetails?.ServiceNo,
//       });

//       // Update local state
//       setBooking(updatedBooking);
//       setTripStage("trip_started");
//       initializeHireBubble(updatedBooking);
      
//       toast.success("✅ Trip started! Heading to destination");
//     } catch (err) {
//       console.error("[DriverTrip] Failed to start trip:", err);
//       toast.error("Failed to update status. Please try again.");
//     }
//   };

//   const handleStartTrip = async () => {
//     try {
//       if (!booking?.bId) {
//         toast.error("No booking loaded");
//         return;
//       }

//       // Status is already IP from handleArrivedAtPickup
//       // This is just a button confirmation, no status change needed
//       toast.info("✓ Trip already started");
//       setTripStage("trip_started");
//     } catch (err) {
//       console.error("[DriverTrip] Failed to confirm trip start:", err);
//       toast.error("Failed to confirm. Please try again.");
//     }
//   };

//   const handleCompleteTrip = async () => {
//     try {
//       if (!booking?.bId) {
//         toast.error("No booking loaded");
//         return;
//       }

//       // Update booking status to C (Completed) via API
//       const now = new Date();
//       const isoDate = now.toISOString().slice(0, 10);
//       const timeStr = now.toTimeString().slice(0, 8);
//       const completionTime = `${isoDate} ${timeStr}`;

//       const updatedBooking = {
//         ...booking,
//         status: "CO", // Completed
//         beTime: completionTime,
//       };

//       const payload = [
//         {
//           bId: String(booking.bId),
//           status: "CO",
//           beTime: completionTime,
//         },
//       ];
//       await postForkBookingForDriver(payload);

//       // Send WebSocket update
//       bookingWS.sendStatusUpdate({
//         bId: booking.bId,
//         status: "CO",
//         dlatitude: driverLocation?.latitude,
//         dlongitude: driverLocation?.longitude,
//         vId: booking.vId,
//         dSNo: userDetails?.ServiceNo,
//         beTime: completionTime,
//       });

//       // Update local state
//       setBooking(updatedBooking);
//       setTripStage("completed");
//       initializeHireBubble(updatedBooking);

//       // Clear vehicle bStatus so it's available again
//       await resetVehicleBStatus();
      
//       toast.success("✅ Trip completed! Thank you.");
      
//       // Redirect after short delay
//       setTimeout(() => {
//         navigate("/driver/dashboard");
//       }, 2000);
//     } catch (err) {
//       console.error("[DriverTrip] Failed to complete trip:", err);
//       toast.error("Failed to complete trip. Please try again.");
//     }
//   };

//   // Initial load - ALWAYS fetch from API for fresh data
//   useEffect(() => {
//     if (!bookingId) {
//       setLoadError("No booking ID provided");
//       setIsLoading(false);
//       return;
//     }

//     const loadBooking = async () => {
//       try {
//         setIsLoading(true);
//         setLoadError(null);
        
//         console.log(`[DriverTrip] Fetching booking details for bId: ${bookingId}`);
//         const b = await getLatestBookingById(bookingId);
//         if (b) {
//           console.log("[DriverTrip] Booking found - bId:", b.bId, "Status:", b.status, "vId:", b.vId);
//           setBooking(b);

//           try {
//             const vehicle = await getVehicleById(b.vId);
//             if (vehicle?.vehicleType) {
//               console.log("[DriverTrip] Vehicle type found:", vehicle.vehicleType);
//               setVehicleType(vehicle.vehicleType);
//             }
//           } catch (vErr) {
//             console.error("[DriverTrip] Failed to fetch vehicle type:", vErr);
//           }

//           const stage = determineInitialTripStage(b);
//           console.log("[DriverTrip] Setting tripStage to:", stage);
//           setTripStage(stage);
//           initializeHireBubble(b);
//           fetchEmployeePhoneNumber(b.bookingSno || b.BookingSno);
//           setIsLoading(false);
//         } else {
//           setLoadError(`Booking #${bookingId} not found`);
//           setIsLoading(false);
//         }
//       } catch (err) {
//         console.error("[DriverTrip] Failed to fetch booking:", err);
//         setLoadError("Failed to load trip details");
//         setIsLoading(false);
//       }

//       // Connect Chat WebSocket for Emergency Alerts
//       if (authKey && userDetails?.ServiceNo) {
//         chatWS.connect(authKey, userDetails.ServiceNo, "Driver");
//       }
//     };

//     loadBooking();
//   }, [bookingId, authKey, userDetails?.ServiceNo]);

//   // Get initial location
//   useEffect(() => {
//     const getInitialLocation = async () => {
//       const loc = await getCurrentLocation();
//       if (loc) setDriverLocation(loc);
//     };
//     getInitialLocation();
//   }, []);

//   // Start location updates and load routes
//   useEffect(() => {
//     // Initialize hire bubble when booking is loaded
//     if (booking) {
//       initializeHireBubble(booking);
//     }
//   }, [booking, tripStage]);
//   useEffect(() => {
//     if (!booking || !driverLocation) return;

//     loadRoutes();
//     // Update every 15 seconds to match locationWS automatic interval (prevents duplicate updates)
//     locationInterval.current = setInterval(updateDriverLocation, 15000);

//     // Connect location WebSocket
//     if (authKey) {
//       locationWS.connect(authKey, {
//         vehicleId: booking.vId,
//         driverSno: userDetails?.ServiceNo,
//         driverName: userDetails?.Name,
//         latitude: driverLocation.latitude,
//         longitude: driverLocation.longitude,
//         status: "Active",
//         bStatus: "Booking",
//         oStatus: "O",
//       });
//     }

//     return () => {
//       if (locationInterval.current) clearInterval(locationInterval.current);
//     };
//   }, [booking, driverLocation?.latitude]);

//   // Subscribe to tracking WebSocket to reflect server-side live location
//   useEffect(() => {
//     if (!booking?.vId || !authKey) return;

//     // Ensure tracking WS connected
//     trackingWS.connect(authKey);

//     const unsubscribe = trackingWS.subscribe(booking.vId, (msg) => {
//       if (msg && msg.latitude != null && msg.longitude != null) {
//         setDriverLocation({ latitude: msg.latitude, longitude: msg.longitude });
//       }
//     });

//     return () => {
//       if (unsubscribe) unsubscribe();
//     };
//   }, [booking?.vId, authKey]);

//   // 🔴 Listen for booking cancellation from employee (Active/En Route stages)
//   // Uses SAME pattern as DriverDashboard which is already working
//   useEffect(() => {
//     if (!booking?.bId || !authKey || !userDetails?.ServiceNo) return;

//     console.log("[DriverTrip] 🔌 Connecting to bookingWS for cancellation listening...");
    
//     // Connect to booking WebSocket (same as DriverDashboard does)
//     bookingWS.connect(authKey, userDetails.ServiceNo, booking.vId);

//     // Listen for cancellation - SAME pattern as DriverDashboard
//     bookingWS.onNewBooking((msg) => {
//       console.log("[DriverTrip] 📥 Received booking message:", msg);
//       // Only show toast if this driver is the dSNo
//       if (
//         msg.dSNo && userDetails?.ServiceNo &&
//         msg.dSNo.toString() !== userDetails.ServiceNo.toString()
//       ) {
//         return; // Not for this driver
//       }
//       // Check if this is a cancellation message
//       if (msg.type === "booking_cancelled" || msg.action === "booking_cancelled") {
//         // Check if it's for THIS booking
//         if (msg.bId?.toString() === booking.bId?.toString()) {
//           console.log("[DriverTrip] 🚫 THIS booking cancelled by employee! bId:", msg.bId);
//           // Show toast
//           toast.error("🚫 Hire cancelled by employee!", {
//             position: "top-center",
//             autoClose: 4000,
//           });
//           // Clear vehicle bStatus
//           resetVehicleBStatus();
//           // Redirect to dashboard after short delay
//           setTimeout(() => {
//             navigate("/driver/dashboard");
//           }, 1500);
//         }
//       }
//     });

//     return () => {
//       bookingWS.onNewBooking(null);
//     };
//   }, [booking?.bId, booking?.vId, authKey, userDetails?.ServiceNo, navigate]);

//   // 🔴 NEW: Prevent page refresh during active trip stages
//   useEffect(() => {
//     const handleBeforeUnload = (e) => {
//       // Check if trip is in active stages (not completed or cancelled)
//       const isActiveTrip = booking && 
//         tripStage !== "completed" && 
//         booking.status !== "C" && 
//         booking.status !== "CANCELLED";

//       if (isActiveTrip) {
//         e.preventDefault();
//         e.returnValue = "You have an active trip in progress. Are you sure you want to leave? This may affect the trip status.";
//         return e.returnValue;
//       }
//     };

//     // Add event listener
//     window.addEventListener("beforeunload", handleBeforeUnload);

//     // Cleanup
//     return () => {
//       window.removeEventListener("beforeunload", handleBeforeUnload);
//     };
//   }, [booking, tripStage]);

//   // 🔴 NEW: Loading state UI
//   if (isLoading) {
//     return (
//       <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-900 to-purple-900">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white mx-auto mb-4"></div>
//           <div className="text-3xl font-bold text-white">Loading Trip...</div>
//           <p className="text-white/70 mt-2">Fetching latest booking data</p>
//         </div>
//       </div>
//     );
//   }

//   // 🔴 NEW: Error state UI
//   if (loadError) {
//     return (
//       <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-900 to-purple-900">
//         <div className="text-center bg-white/10 backdrop-blur-lg p-8 rounded-3xl max-w-md">
//           <div className="text-6xl mb-4">❌</div>
//           <p className="text-xl font-bold text-red-400">{loadError}</p>
//           <p className="text-white/70 mt-2">Please try again</p>
//           <div className="flex gap-4 justify-center mt-6">
//             <button 
//               onClick={() => window.location.reload()}
//               className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
//             >
//               🔄 Retry
//             </button>
//             <button 
//               onClick={() => navigate("/driver/dashboard")}
//               className="px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition"
//             >
//               ← Dashboard
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Waiting for location
//   if (!booking || !driverLocation) {
//     return (
//       <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-900 to-purple-900">
//         <div className="text-center">
//           <div className="text-6xl mb-4">🚗</div>
//           <div className="text-3xl font-bold text-white">Getting Location...</div>
//           <p className="text-white/70 mt-2">Please allow location access</p>
//         </div>
//       </div>
//     );
//   }

//   // Validate coordinates with error fallback
//   const pickup = ensureValidLatLng(booking.slatitude, booking.slongitude);
//   const destination = ensureValidLatLng(booking.elatitude, booking.elongitude);
//   const driverPos = [driverLocation.latitude, driverLocation.longitude];

//   const hasValidCoords = !!pickup && !!destination;

//   // Determine which route to show
//   const showPickupRoute = tripStage === "accepted" || tripStage === "heading_to_pickup";
//   const showDestRoute = tripStage === "trip_started" || tripStage === "completed";

//   // Map bounds
//   const mapBounds = hasValidCoords
//     ? (showPickupRoute ? [driverPos, pickup] : [pickup, destination])
//     : [driverPos];

//   return (
//     <div className="flex flex-col min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-purple-900">
//       <DriverHeader driver={{ name: userDetails?.Name || "Driver" }} isOnline={true} toggleOnline={() => {}} />

//       <main className="flex-1 px-4 py-6 max-w-5xl mx-auto w-full space-y-6">

//         {/* BOOKING INFO CARD */}
//         <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 text-white border border-white/20">
//           {!hasValidCoords && (
//             <div className="mb-4 bg-yellow-500/20 border border-yellow-400/40 text-yellow-100 rounded-2xl p-3 text-sm">
//               Coordinates are missing for this scheduled booking. You can still proceed, but route and map pins will appear once coordinates are available.
//             </div>
//           )}
//           <div className="flex items-center justify-between mb-4">
//             <h2 className="text-2xl font-bold">Booking #{booking.bId}</h2>
//             <span className={`px-4 py-2 rounded-full text-sm font-bold ${
//               tripStage === "completed" ? "bg-green-500" :
//               tripStage === "trip_started" ? "bg-blue-500" :
//               "bg-yellow-500 text-yellow-900"
//             }`}>
//               {tripStage === "accepted" && "NEW BOOKING"}
//               {tripStage === "heading_to_pickup" && "HEADING TO PICKUP"}
//               {tripStage === "trip_started" && "ON TRIP"}
//               {tripStage === "completed" && "COMPLETED"}
//             </span>
//           </div>

//           {/* Employee Info */}
//           <div className="bg-white/10 rounded-2xl p-4 mb-4">
//             <p className="text-sm text-white/70">Requested by</p>
//             <p className="text-xl font-bold">{booking.employeeName || "Employee"}</p>
//             {booking.bookingSno && <p className="text-sm text-white/60">ID: {booking.bookingSno}</p>}
//           </div>

//           {/* From - To */}
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div className="bg-green-500/20 rounded-2xl p-4 border-l-4 border-green-500">
//               <p className="text-sm text-green-300 font-medium">📍 PICKUP LOCATION</p>
//               <p className="text-lg font-bold mt-1">
//                 {pickup
//                   ? `${pickup[0].toFixed(4)}, ${pickup[1].toFixed(4)}`
//                   : (getDisplayLocations(booking).from || "N/A")}
//               </p>
//               {distanceToPickup && (
//                 <p className="text-sm text-green-300 mt-1">{distanceToPickup ? Number(distanceToPickup).toFixed(2) : "..."} km away</p>
//               )}
//             </div>
//             <div className="bg-red-500/20 rounded-2xl p-4 border-l-4 border-red-500">
//               <p className="text-sm text-red-300 font-medium">🎯 DESTINATION</p>
//               <p className="text-lg font-bold mt-1">
//                 {destination
//                   ? `${destination[0].toFixed(4)}, ${destination[1].toFixed(4)}`
//                   : (getDisplayLocations(booking).to || "N/A")}
//               </p>
//               {booking.totalDestence && (
//                 <p className="text-sm text-red-300 mt-1">Trip: {booking.totalDestence ? Number(booking.totalDestence).toFixed(2) : "..."} km</p>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* MAP - Responsive */}
//         <div className="bg-white rounded-3xl shadow-2xl overflow-hidden" style={{ height: "300px", position: "relative", zIndex: "auto" }} onLoad={() => window.dispatchEvent(new Event('resize'))}>
//           <style>{`
//             .leaflet-container { z-index: 1 !important; }
//             .leaflet-popup { z-index: 2 !important; }
//             .leaflet-control { z-index: 2 !important; }
//           `}</style>
//           <MapContainer
//             center={driverPos}
//             zoom={14}
//             style={{ height: "100%", width: "100%", zIndex: 1 }}
//           >
//             <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
//             {hasValidCoords && mapBounds.length >= 2 && <FitBounds bounds={mapBounds} />}

//             {/* Driver Marker */}
//             <Marker position={driverPos} icon={getVehicleIcon(vehicleType)}>
//               <Popup>
//                 <strong>🚗 You are here</strong><br />
//                 {booking.vId}
//               </Popup>
//             </Marker>

//             {/* Pickup Marker */}
//             {hasValidCoords && pickup && (
//               <Marker position={pickup} icon={pickupIcon}>
//                 <Popup>
//                   <strong>📍 Pickup Location</strong><br />
//                   {distanceToPickup} km away
//                 </Popup>
//               </Marker>
//             )}

//             {/* Destination Marker (show after trip started) */}
//             {hasValidCoords && (tripStage === "trip_started" || tripStage === "completed") && destination && (
//               <Marker position={destination} icon={destinationIcon}>
//                 <Popup>
//                   <strong>🎯 Destination</strong><br />
//                   {booking.totalDestence ? Number(booking.totalDestence).toFixed(2) : "..."} km trip
//                 </Popup>
//               </Marker>
//             )}

//             {/* Route to Pickup (blue dashed) */}
//             {hasValidCoords && showPickupRoute && routeToPickup.length > 0 && (
//               <Polyline 
//                 positions={routeToPickup} 
//                 color="#3b82f6" 
//                 weight={6} 
//                 opacity={0.9}
//                 dashArray="10, 10"
//               />
//             )}

//             {/* Route to Destination (red solid) */}
//             {hasValidCoords && showDestRoute && routeToDestination.length > 0 && (
//               <Polyline 
//                 positions={routeToDestination} 
//                 color="#ef4444" 
//                 weight={6} 
//                 opacity={0.9}
//               />
//             )}
//           </MapContainer>
//         </div>

//         {/* ACTION BUTTONS */}
//         <div className="space-y-4">
//           {tripStage === "accepted" && (
//             <button
//               onClick={handleStartToPickup}
//               className="w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white py-6 rounded-2xl font-bold text-2xl shadow-2xl transition transform hover:scale-[1.02] flex items-center justify-center gap-3"
//             >
//               <span className="text-3xl">🚀</span>
//               START - Head to Pickup
//             </button>
//           )}

//           {tripStage === "heading_to_pickup" && (
//             <div className="space-y-4">
//               <CallEmployeeButton
//                 employeeName={booking.employeeName || "Employee"}
//                 employeePhone={employeePhoneNumber}
//                 showSMS={true}
//                 className="w-full"
//                 buttonSize="md"
//               />
//               <button
//                 onClick={handleArrivedAtPickup}
//                 className="w-full bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white py-6 rounded-2xl font-bold text-2xl shadow-2xl transition transform hover:scale-[1.02] flex items-center justify-center gap-3"
//               >
//                 <span className="text-3xl">📍</span>
//                 I'VE ARRIVED at Pickup
//               </button>
//             </div>
//           )}

//           {tripStage === "trip_started" && (
//             <div className="space-y-4">
//               <CallEmployeeButton
//                 employeeName={booking.employeeName || "Employee"}
//                 employeePhone={employeePhoneNumber}
//                 showSMS={true}
//                 className="w-full"
//                 buttonSize="md"
//               />
//               <button
//                 onClick={handleCompleteTrip}
//                 className="w-full bg-gradient-to-r from-purple-500 to-pink-600 hover:from-purple-600 hover:to-pink-700 text-white py-6 rounded-2xl font-bold text-2xl shadow-2xl transition transform hover:scale-[1.02] flex items-center justify-center gap-3"
//               >
//                 <span className="text-3xl">✅</span>
//                 COMPLETE TRIP
//               </button>
//             </div>
//           )}

//           {tripStage === "completed" && (
//             <div className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-6 rounded-2xl font-bold text-2xl text-center shadow-2xl animate-pulse">
//               <span className="text-3xl mr-2">🎉</span>
//               TRIP COMPLETED SUCCESSFULLY!
//             </div>
//           )}
//         </div>

//         {/* Distance Info Bar */}
//         {tripStage !== "completed" && (
//           <div className="bg-white/10 backdrop-blur rounded-2xl p-4 flex justify-around text-white text-center">
//             <div>
//               <p className="text-sm text-white/70">To Pickup</p>
//               <p className="text-2xl font-bold">{distanceToPickup ? Number(distanceToPickup).toFixed(2) : "..."} km</p>
//             </div>
//             <div className="border-l border-white/20 pl-8">
//               <p className="text-sm text-white/70">Trip Distance</p>
//               <p className="text-2xl font-bold">{booking.totalDestence ? Number(booking.totalDestence).toFixed(2) : "..."} km</p>
//             </div>
//           </div>
//         )}
//       </main>

//       <DriverFooter />

//       {/* Hire Assistance Bubble - Google Maps Navigation (EN and IP stages only) */}
//       {pickup && destination && (
//         <HireAssistanceBubble
//           tripStage={tripStage}
//           pickupLocation={pickup ? {
//             lat: pickup[0],
//             lng: pickup[1],
//           } : null}
//           destinationLocation={destination ? {
//             lat: destination[0],
//             lng: destination[1],
//           } : null}
//           driverLocation={driverLocation ? {
//             lat: driverLocation.latitude,
//             lng: driverLocation.longitude,
//           } : null}
//           onEmergency={handleOpenEmergency}
//         />
//       )}

//       <EmergencyAlertModal
//         isOpen={isEmergencyModalOpen}
//         onClose={() => setIsEmergencyModalOpen(false)}
//         onSend={handleSendEmergency}
//         isSending={isSendingEmergency}
//       />
//     </div>
//   );
// };

// export default DriverTrip;

//----------------------------------------------------------------------------------------------------


// import React, { useState, useEffect, useRef } from "react";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { defaultUserImg } from "../assets/defaultUser";
// import {
//   MapContainer,
//   TileLayer,
//   Marker,
//   Popup,
//   Polyline,
//   useMap,
// } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
// import L from "leaflet";

// // Import vehicle icons
// import carIcon from "../assets/car.png";
// import vanIcon from "../assets/van.png";
// import busIcon from "../assets/bus.png";
// import lorryIcon from "../assets/lorry.png";
// import suvIcon from "../assets/suv.png";
// import cabIcon from "../assets/cab.png";
// import forkliftIcon from "../assets/fork lift.png";
// import dockyardIcon from "../assets/dockyard.png";
// import cherryIcon from "../assets/cherry.png";
// import craneIcon from "../assets/crane.jpg";
// import DriverHeader from "../components/DriverHeader";
// import DriverFooter from "../components/DriverFooter";
// import CallEmployeeButton from "../components/CallEmployeeButton";
// import HireAssistanceBubble from "../components/HireAssistanceBubble";
// import { useDispatch, useSelector } from "react-redux";
// import api from "../services/api";
// import { calculateDistance, estimateETA, calculateFare } from "../services/mapsService";
// import locationWS from "../services/locationWebSocket";
// import trackingWS from "../services/trackingWebSocket";
// import bookingWS from "../services/bookingWebSocket";  // 🔴 NEW
// import chatWS from "../services/chatWebSocket"; // NEW
// import EmergencyAlertModal from "../components/EmergencyAlertModal"; // NEW
// import { updateEmergency } from "../services/vehicleService"; // NEW
// import { fetchBookings } from "../actions/BookingActions";
// import { getForkBookingDetails, postForkBookingForDriver,PostRequestedstatus,  getMainForkBookingDetailsbid } from "../services/bookingService";
// import { fetchUsers } from "../actions/UserActions";
// import { fetchVehicles } from "../actions/VehicleActions";

// // Fix Leaflet icon
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
//   iconUrl: require("leaflet/dist/images/marker-icon.png"),
//   shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
// });

// // Helper to validate and parse coordinates
// const parseCoordinate = (value) => {
//   const parsed = parseFloat(value);
//   return !isNaN(parsed) ? parsed : null;
// };

// // Helper to ensure valid LatLng array
// const ensureValidLatLng = (lat, lng) => {
//   const validLat = parseCoordinate(lat);
//   const validLng = parseCoordinate(lng);
//   if (validLat !== null && validLng !== null) {
//     return [validLat, validLng];
//   }
//   return null;
// };

// // Function to get vehicle icon based on type (supports both codes and full names)
// const getVehicleIcon = (vehicleType) => {
//   const type = vehicleType?.toUpperCase()?.trim() || "C";
//   let iconUrl = carIcon;
  
//   // Match by code first, then by name
//   if (type === "V" || type.includes("VAN")) iconUrl = vanIcon;
//   else if (type === "B" || type.includes("BUS")) iconUrl = busIcon;
//   else if (type === "L" || type.includes("LORRY") || type.includes("TRUCK")) iconUrl = lorryIcon;
//   else if (type === "S" || type.includes("SUV")) iconUrl = suvIcon;
//   else if (type === "CA" || type.includes("CAB") || type.includes("TAXI")) iconUrl = cabIcon;
//   else if (type === "F" || type.includes("FORKLIFT") || type.includes("FORK")) iconUrl = forkliftIcon;
//   else if (type.includes("DOCKYARD")) iconUrl = dockyardIcon;
//   else if (type === "CH" || type.includes("CHERRY")) iconUrl = cherryIcon;
//   else if (type === "CR" || type.includes("CRANE")) iconUrl = craneIcon;
//   else if (type === "C" || type.includes("CAR")) iconUrl = carIcon;
  
//   return new L.Icon({
//     iconUrl: iconUrl,
//     iconSize: [45, 45],
//     iconAnchor: [22, 45],
//     popupAnchor: [0, -45],
//   });
// };

// const pickupIcon = new L.Icon({
//   iconUrl: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
//   iconSize: [40, 40],
//   iconAnchor: [20, 40],
//   popupAnchor: [0, -40],
// });

// const destinationIcon = new L.Icon({
//   iconUrl: "https://cdn-icons-png.flaticon.com/512/149/149060.png",
//   iconSize: [40, 40],
//   iconAnchor: [20, 40],
//   popupAnchor: [0, -40],
// });

// // Map auto-fit to show all points (only once initially)
// const FitBounds = ({ bounds }) => {
//   const map = useMap();
//   const hasFitted = useRef(false);

//   useEffect(() => {
//     if (bounds && bounds.length >= 2 && !hasFitted.current) {
//       map.fitBounds(bounds, { padding: [50, 50], maxZoom: 15 });
//       hasFitted.current = true; // Only fit once
//     }
//   }, [bounds, map]);
//   return null;
// };

// // Fetch route from OpenRouteService
// const fetchRoute = async (start, end) => {
//   const apiKey = process.env.REACT_APP_ORS_KEY;
//   if (!apiKey) return null;
//   try {
//     const url = `https://api.openrouteservice.org/v2/directions/driving-car?api_key=${apiKey}&start=${start[1]},${start[0]}&end=${end[1]},${end[0]}`;
//     const res = await fetch(url);
//     const data = await res.json();
//     const coords = data.features?.[0]?.geometry?.coordinates;
//     if (coords) {
//       return coords.map(([lng, lat]) => [lat, lng]);
//     }
//   } catch (e) {
//     console.error("Route fetch error:", e);
//   }
//   return null;
// };

// const DriverTrip = () => {
//   const dispatch = useDispatch();
//   const getBookings = async () => dispatch(fetchBookings());
//   const getUsers = async () => dispatch(fetchUsers());
//   const getVehicles = async () => dispatch(fetchVehicles());
//   const { authKey, userDetails } = useSelector((state) => state.auth);
//   const { bookingId } = useParams();
//   const navigate = useNavigate();
//   const location = useLocation();

//   // reqId passed via navigation state when driver accepts from overlay popup
//   // this avoids the race condition where PostForkBooking hasn't finished writing
//   // reqId to the DB before DriverTrip mounts and tries to fetch it
//   const passedReqId = location.state?.reqId || null;

//   // 🔴 REMOVED: No longer using location.state - always fetch fresh from API
//   // This ensures refresh works and status is always up-to-date

//   // Determine initial trip stage based on booking status - SINGLE SOURCE OF TRUTH
//   const determineInitialTripStage = (bookingData) => {
//     console.log("[DriverTrip] determineInitialTripStage called with:", bookingData);
    
//     if (!bookingData) {
//       console.log("[DriverTrip] No booking data, returning 'accepted'");
//       return "accepted";
//     }
    
//     const status = bookingData.status?.toUpperCase()?.trim() || "";
//     console.log("[DriverTrip] determineInitialTripStage - booking.status raw:", bookingData.status);
//     console.log("[DriverTrip] determineInitialTripStage - booking status (uppercase, trimmed):", status);
    
//     if (status === "A" || status === "ACTIVE") {
//       console.log("[DriverTrip] Status is A/ACTIVE → returning 'accepted'");
//       return "accepted";
//     } else if (status === "EN" || status === "ENROUTE") {
//       console.log("[DriverTrip] Status is EN/ENROUTE → returning 'heading_to_pickup'");
//       return "heading_to_pickup";
//     } else if (status === "IP" || status === "INPROGRESS" || status === "IN PROGRESS") {
//       console.log("[DriverTrip] Status is IP/INPROGRESS/IN PROGRESS → returning 'trip_started'");
//       return "trip_started";
//     }
    
//     console.log("[DriverTrip] Status not matched, defaulting to 'accepted'");
//     return "accepted";
//   };

//   // 🔴 NEW: Loading and error states
//   const [isLoading, setIsLoading] = useState(true);
//   const [loadError, setLoadError] = useState(null);

//   const [booking, setBooking] = useState(null);
//   const [vehicleType, setVehicleType] = useState("C"); // Vehicle type for map icon
//   // Stages: accepted → heading_to_pickup → arrived_at_pickup → trip_started → completed
//   const [tripStage, setTripStage] = useState("accepted");

//   const getLatestBookingById = async (id) => {
//     const allBookings = await getBookings();
//     const found = allBookings.find((b) => b.bId?.toString() === id?.toString()) || null;
//     if (found && (found.bsTime || found.beTime)) return found;

//     try {
//       const forkDetails = await getForkBookingDetails(id);
//       if (Array.isArray(forkDetails) && forkDetails[0]) {
//         return { ...found, ...forkDetails[0] };
//       }
//       if (forkDetails && typeof forkDetails === "object") {
//         return { ...found, ...forkDetails };
//       }
//     } catch (err) {
//       console.warn("[DriverTrip] Failed to load fork booking details for status normalization:", err);
//     }

//     return found;
//   };

//   const getVehicleById = async (id) => {
//     const vehicles = await getVehicles();
//     return vehicles.find((v) => v.vehicleId?.toString() === id?.toString()) || null;
//   };

//   const getEmployeeByServiceNo = async (serviceNo) => {
//     const users = await getUsers();
//     return users.find((u) => u.ServiceNo?.toString() === serviceNo?.toString()) || null;
//   };
//   const [driverLocation, setDriverLocation] = useState(null);
//   const [routeToPickup, setRouteToPickup] = useState([]);
//   const [routeToDestination, setRouteToDestination] = useState([]);
//   const [distanceToPickup, setDistanceToPickup] = useState(null);
//   const [distanceToDestination, setDistanceToDestination] = useState(null);
//   const [employeePhoneNumber, setEmployeePhoneNumber] = useState(null);
//   const [activeHire, setActiveHire] = useState(null);
//   const [hireStage, setHireStage] = useState('accepted');
//   const [isEmergencyModalOpen, setIsEmergencyModalOpen] = useState(false); // NEW
//   const [isSendingEmergency, setIsSendingEmergency] = useState(false); // NEW
//   const lastRouteRefresh = useRef(0);

//   const locationInterval = useRef(null);

//   const resolveSubBookingForVehicle = (bookingData) => {
//     if (!bookingData) return null;
//     const subBookings =
//       bookingData.SubBookings ||
//       bookingData.subBookings ||
//       bookingData.subBooking ||
//       bookingData.subBookingDetails ||
//       [];
//     if (!Array.isArray(subBookings) || subBookings.length === 0) return null;
//     const vId = String(bookingData?.vId || "");
//     return (
//       subBookings.find((sub) => String(sub?.subvid || sub?.subvId || sub?.vId || sub?.vid || "") === vId) ||
//       null
//     );
//   };

//   const getDisplayLocations = (bookingData) => {
//     if (!bookingData) return { from: "", to: "" };
//     const baseFrom = bookingData.From || bookingData.fromLocation || bookingData.WorkArea || "";
//     const baseTo = bookingData.TO || bookingData.toLocation || "";
//     if (baseFrom || baseTo) return { from: baseFrom, to: baseTo };
//     const sub = resolveSubBookingForVehicle(bookingData);
//     if (!sub) return { from: "", to: "" };
//     const subFrom = sub.subFrom || sub.From || sub.from || "";
//     const subTo = sub.subTO || sub.TO || sub.to || "";
//     return { from: subFrom || "", to: subTo || "" };
//   };

//   // Handle Emergency Alert
//   const handleOpenEmergency = () => {
//     setIsEmergencyModalOpen(true);
//   };

//   const handleSendEmergency = async ({ ecode, ediscription }) => {
//     if (!booking?.vId) {
//       toast.error("No vehicle assigned. Cannot send alert.");
//       return;
//     }

//     setIsSendingEmergency(true);
//     try {
//       // 1. Update Backend (Database)
//       await updateEmergency(booking.vId, ecode, ediscription);
      
//       // 2. Notify Admins via WebSocket (Real-time)
//       const success = chatWS.sendEmergency({
//         vehicleId: booking.vId,
//         ecode: ecode,
//         ediscription: ediscription,
//         driverName: userDetails?.Name || "Driver",
//         driverSno: userDetails?.ServiceNo || "",
//         mobileNo: "N/A" // Mobile not available in this context
//       });

//       if (!success) {
//         console.warn("WebSocket send failed for emergency, but DB updated.");
//       }

//       toast.success("EMERGENCY ALERT SENT! Help is on the way.");
//       setIsEmergencyModalOpen(false);
//     } catch (error) {
//       console.error("Emergency Alert Failed:", error);
//       toast.error("Failed to send alert! Please call emergency services.");
//     } finally {
//       setIsSendingEmergency(false);
//     }
//   };

//   // Get current location
//   const getCurrentLocation = () => {
//     return new Promise((resolve) => {
//       if ("geolocation" in navigator) {
//         navigator.geolocation.getCurrentPosition(
//           (pos) => {
//             resolve({
//               latitude: parseFloat(pos.coords.latitude.toFixed(6)),
//               longitude: parseFloat(pos.coords.longitude.toFixed(6)),
//             });
//           },
//           () => resolve(driverLocation),
//           { enableHighAccuracy: true, timeout: 10000 }
//         );
//       } else {
//         resolve(driverLocation);
//       }
//     });
//   };

//   // Calculate distance between two points (km)
//   const haversineDistance = (lat1, lon1, lat2, lon2) => {
//     const R = 6371;
//     const dLat = (lat2 - lat1) * Math.PI / 180;
//     const dLon = (lon2 - lon1) * Math.PI / 180;
//     const a = Math.sin(dLat/2) ** 2 + Math.cos(lat1 * Math.PI/180) * Math.cos(lat2 * Math.PI/180) * Math.sin(dLon/2) ** 2;
//     return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//   };

//   // Initialize hire bubble with booking data
//   const initializeHireBubble = (bookingData) => {
//     if (!bookingData) return;

//     const pickup = ensureValidLatLng(bookingData.slatitude, bookingData.slongitude);
//     const destination = ensureValidLatLng(bookingData.elatitude, bookingData.elongitude);

//     if (!pickup || !destination) {
//       console.warn("[DriverTrip] Invalid coordinates for hire bubble:", {
//         pickup: bookingData.slatitude,
//         destination: bookingData.elatitude,
//       });
//       return;
//     }

//     const distance = calculateDistance(
//       { lat: pickup[0], lng: pickup[1] },
//       { lat: destination[0], lng: destination[1] }
//     );
//     const eta = estimateETA(distance);
//     const fare = calculateFare(distance);

//     setActiveHire({
//       hireId: bookingData.bId,
//       bookingId: bookingData.bId,
//       status: tripStage,
//       pickupLocation: { lat: pickup[0], lng: pickup[1] },
//       destinationLocation: { lat: destination[0], lng: destination[1] },
//       distance: distance,
//       eta: eta,
//       fare: fare,
//     });

//     setHireStage(tripStage);
//   };

//   const normalizeBookingStatusCode = (bookingOrValue) => {
//     const raw = bookingOrValue?.BookingStatus ?? bookingOrValue;
//     const normalized = String(raw || "").trim().toUpperCase();
//     const hasScheduleTimes = Boolean(bookingOrValue?.bsTime && bookingOrValue?.beTime);
//     const isScheduledLabel =
//       normalized === "S" || normalized === "SHEDULE BOOKING" || normalized === "SCHEDULE BOOKING";
//     const isRealtimeLabel =
//       normalized === "R" || normalized === "REAL-TIME BOOKING" || normalized === "REAL TIME BOOKING";

//     if (isScheduledLabel) return "S";
//     if (hasScheduleTimes) return "S";
//     return "R";
//   };

//   // Update driver location and send to WebSocket
//   const updateDriverLocation = async () => {
//     const loc = await getCurrentLocation();
//     if (!loc) return;
    
//     setDriverLocation(loc);

//     // Calculate distances
//     if (booking) {
//       const pickup = ensureValidLatLng(booking.slatitude, booking.slongitude);
//       const dest = ensureValidLatLng(booking.elatitude, booking.elongitude);
      
//       if (pickup) {
//         setDistanceToPickup(haversineDistance(loc.latitude, loc.longitude, pickup[0], pickup[1]).toFixed(1));
//       }
//       if (dest) {
//         setDistanceToDestination(haversineDistance(loc.latitude, loc.longitude, dest[0], dest[1]).toFixed(2));
//       }
//     }

//     // Update vehicle in DB and WebSocket - ONLY update location
//     if (booking?.vId) {
//       try {
//         const payload = [{
//           vehicleId: booking.vId,
//           status: "A",
//           latitude: loc.latitude,
//           longitude: loc.longitude,
//         }];
//         await api.post("/VehicleRegister/UpdateVehicleLocation", payload);
        
//         // Send location via WebSocket for live tracking
//         if (locationWS.isReady()) {
//           locationWS.updateDriverData({
//             latitude: loc.latitude,
//             longitude: loc.longitude,
//             bStatus: "B",
//           });
//         }
//       } catch (err) {
//         console.error("Location update failed", err);
//       }
//     }
//   };

//   // Clear bStatus after trip completion so vehicle reappears on maps (use full payload shape)
//   const resetVehicleBStatus = async () => {
//     if (!booking?.vId) return;

//     const loc = await getCurrentLocation();
//     let vehicle = null;

//     try {
//       vehicle = await getVehicleById(booking.vId);
//     } catch (err) {
//       console.error("Failed to fetch vehicle before reset bStatus:", err.response?.data || err.message);
//     }

//     // Build payload similar to updateVehicleInDB/updateVehicleBookingStatus for consistency
//     const typeCodeMap = {
//       Car: "C", Van: "V", Lorry: "L", SUV: "S", Cab: "CA",
//       Bus: "B", "Cherry Picker": "CH", Forklift: "F", Crane: "CR", Trailer: "T",
//     };
//     const vehicleTypeCode = typeCodeMap[vehicle?.vehicleType] || vehicle?.vehicleType || "C";
//     const statusCode = vehicle?.status === "Inactive" ? "I" : vehicle?.status === "Active" ? "A" : "A";
//     const oStatusValue = "O"; // keep online so it shows immediately

//     const payload = [{
//       vehicleId: vehicle?.vehicleId || booking.vId,
//       vehicleType: vehicleTypeCode,
//       weightCat: vehicle?.weightCat || "",
//       driverSno: vehicle?.driverSno || userDetails?.ServiceNo || "",
//       status: statusCode,
//       bStatus: "", // make vehicle available
//       oStatus: oStatusValue,
//       latitude: loc?.latitude ?? vehicle?.latitude ?? "",
//       longitude: loc?.longitude ?? vehicle?.longitude ?? "",
//     }];

//     try {
//       await api.post("/VehicleRegister/PostVehicleDetails", payload);
//       console.log("Reset bStatus to empty for vehicle", booking.vId);

//       // Push real-time update so map reappears immediately with correct vehicle type
//       locationWS.updateDriverData({
//         vehicleId: vehicle?.vehicleId || booking.vId,
//         vehicle_type: vehicle?.vehicleType || "Car", // Full name for icon
//         vehicleType: vehicle?.vehicleType || "Car",
//         latitude: payload[0].latitude,
//         longitude: payload[0].longitude,
//         bStatus: "",
//         oStatus: "O",
//         status: statusCode,
//       });
//       if (locationWS.isReady()) {
//         locationWS.sendLocationUpdate();
//       }
//     } catch (err) {
//       console.error("Failed to reset vehicle bStatus:", err.response?.data || err.message);
//     }
//   };

// //reqid
// const fetchReqIdForBooking = async (bId, passedReqId = null) => {
//   // if reqId was passed via navigation state (accept overlay flow), use it directly
//   if (passedReqId) {
//     console.log(`[DriverTrip] Using passedReqId from navigation state: ${passedReqId}`)
//     return String(passedReqId)
//   }
//   try {
//     console.log(`[DriverTrip] Fetching reqId for booking ${bId}`);
//     const response = await getMainForkBookingDetailsbid(bId);
//     console.log("[DriverTrip] API Response:", response);
    
//     // Handle different response structures
//     let reqId = null;
    
//     // Case 1: Response is an array with reqId in first element
//     if (response && Array.isArray(response)) {
//       console.log("[DriverTrip] Response is array, length:", response.length);
//       if (response.length > 0) {
//         reqId = response[0]?.reqId || response[0]?.ReqId;
//       }
//     } 
//     // Case 2: Response has data property
//     else if (response?.data) {
//       console.log("[DriverTrip] Response has data property");
//       if (Array.isArray(response.data)) {
//         reqId = response.data[0]?.reqId || response.data[0]?.ReqId;
//       } else if (response.data.reqId || response.data.ReqId) {
//         reqId = response.data.reqId || response.data.ReqId;
//       }
//     }
//     // Case 3: Response is an object with reqId directly
//     else if (response?.reqId || response?.ReqId) {
//       reqId = response.reqId || response.ReqId;
//     }
//     // Case 4: Response has resultSet
//     else if (response?.resultSet && Array.isArray(response.resultSet) && response.resultSet.length > 0) {
//       reqId = response.resultSet[0]?.reqId || response.resultSet[0]?.ReqId;
//     }
    
//     if (!reqId) {
//       console.error("[DriverTrip] No reqId found in response:", response);
//       // Fallback to bId if reqId not found
//       console.warn("[DriverTrip] Using bId as fallback reqId");
//       return String(bId);
//     }
    
//     console.log("[DriverTrip] Successfully found reqId:", reqId);
//     return String(reqId);
//   } catch (err) {
//     console.error("[DriverTrip] Failed to fetch reqId:", err);
//     console.error("[DriverTrip] Error response:", err.response?.data);
//     // Fallback to bId on error
//     console.warn("[DriverTrip] Using bId as fallback due to error");
//     return String(bId);
//   }
// };
//   // Fetch routes
//   const loadRoutes = async () => {
//     if (!booking || !driverLocation) return;

//     const pickup = ensureValidLatLng(booking.slatitude, booking.slongitude);
//     const dest = ensureValidLatLng(booking.elatitude, booking.elongitude);

//     if (!pickup || !dest) {
//       console.warn("[DriverTrip] Cannot load routes - invalid coordinates");
//       return;
//     }

//     const driver = [driverLocation.latitude, driverLocation.longitude];

//     // Route from driver to pickup
//     const toPickup = await fetchRoute(driver, pickup);
//     if (toPickup) setRouteToPickup(toPickup);

//     // Route from pickup to destination
//     const toDest = await fetchRoute(pickup, dest);
//     if (toDest) setRouteToDestination(toDest);
//   };

//   // Recompute routes when driver moves (throttled to avoid spam)
//   useEffect(() => {
//     const now = Date.now();
//     if (!booking || !driverLocation) return;
//     if (now - lastRouteRefresh.current < 30000) return; // throttle 30s
//     lastRouteRefresh.current = now;
//     loadRoutes();
//   }, [driverLocation?.latitude, driverLocation?.longitude, booking, tripStage]);

//   // Fetch employee phone number using their ServiceNo
//   const fetchEmployeePhoneNumber = async (employeeServiceNo) => {
//     if (!employeeServiceNo) {
//       console.log("No employee service number provided");
//       setEmployeePhoneNumber(null);
//       return;
//     }

//     try {
//       const employee = await getEmployeeByServiceNo(employeeServiceNo);
//       if (employee && employee.MobileNo) {
//         console.log("Setting phone number:", employee.MobileNo);
//         setEmployeePhoneNumber(employee.MobileNo);
//       } else {
//         console.log("No mobile number found for employee");
//         setEmployeePhoneNumber(null);
//       }
//     } catch (err) {
//       console.error("Failed to fetch employee phone number:", err);
//       setEmployeePhoneNumber(null);
//     }
//   };

//   // Stage Actions
//   // const handleStartToPickup = async () => {
//   //   try {
//   //     if (!booking?.bId) {
//   //       toast.error("No booking loaded");
//   //       return;
//   //     }

//   //      const reqId = await fetchReqIdForBooking(booking.bId);


//   //     // Update booking status to EN (EnRoute) via API (status-only to avoid overwrite)
//   //     const updatedBooking = {
//   //       ...booking,
//   //       status: "EN", // En Route to pickup
//   //     };

//   //     const payload = [
//   //       {
//   //         bId: String(booking.bId),
//   //         status: "EN",
//   //       },
//   //     ];
//   //     await postForkBookingForDriver(payload);

//   //     await PostRequestedstatus([{
//   //     reqId: String(reqId),
//   //     status: "EN",  // Same status as postForkBookingForDriver
//   //     booking_end_time: null
//   //   }]);

//   //     // Send WebSocket update
//   //     bookingWS.sendStatusUpdate({
//   //       bId: booking.bId,
//   //       status: "EN",
//   //       dlatitude: driverLocation?.latitude,
//   //       dlongitude: driverLocation?.longitude,
//   //       vId: booking.vId,
//   //       dSNo: userDetails?.ServiceNo,
//   //     });

//   //     // Update local state
//   //     setBooking(updatedBooking);
//   //     setTripStage("heading_to_pickup");
//   //     initializeHireBubble(updatedBooking);
      
//   //     toast.success("✅ Heading to pickup location");
//   //   } catch (err) {
//   //     console.error("[DriverTrip] Failed to start trip to pickup:", err);
//   //     toast.error("Failed to update status. Please try again.");
//   //   }
//   // };

//   const handleStartToPickup = async () => {
//   try {
//     if (!booking?.bId) {
//       toast.error("No booking loaded");
//       return;
//     }

//     console.log("[DriverTrip] Step 1: Updating booking status to EN...");
//     // First: Update booking status via postForkBookingForDriver
//     const payload = [{
//       bId: String(booking.bId),
//       status: "EN",
//     }];
//     await postForkBookingForDriver(payload);
//     console.log("[DriverTrip] ✓ postForkBookingForDriver completed");

//     console.log("[DriverTrip] Step 2: Fetching reqId...");
//     // Second: Get reqId from main fork booking details
//     const reqId = await fetchReqIdForBooking(booking.bId, passedReqId);
//     console.log("[DriverTrip] ✓ Got reqId:", reqId);

//     console.log("[DriverTrip] Step 3: Updating requested status...");
//     // Third: Update requested status with the reqId
//     await PostRequestedstatus([{
//       reqId: String(reqId),
//       status: "EN",
//       booking_end_time: null
//     }]);
//     console.log("[DriverTrip] ✓ PostRequestedstatus completed");

//     // Send WebSocket update
//     bookingWS.sendStatusUpdate({
//       bId: booking.bId,
//       status: "EN",
//       dlatitude: driverLocation?.latitude,
//       dlongitude: driverLocation?.longitude,
//       vId: booking.vId,
//       dSNo: userDetails?.ServiceNo,
//     });

//     // Update local state
//     const updatedBooking = {
//       ...booking,
//       status: "EN",
//     };
//     setBooking(updatedBooking);
//     setTripStage("heading_to_pickup");
//     initializeHireBubble(updatedBooking);
    
//     toast.success("✅ Heading to pickup location");
//   } catch (err) {
//     console.error("[DriverTrip] Failed to start trip:", err);
//     toast.error("Failed to update status. Please try again.");
//   }
// };

//   // const handleArrivedAtPickup = async () => {
//   //   try {
//   //     if (!booking?.bId) {
//   //       toast.error("No booking loaded");
//   //       return;
//   //     }

//   //     const reqId = await fetchReqIdForBooking(booking.bId);

//   //     // Update booking status to IP (InProgress) via API (status-only to avoid overwrite)
//   //     const updatedBooking = {
//   //       ...booking,
//   //       status: "IP", // In Progress - started trip
//   //     };

//   //     const payload = [
//   //       {
//   //         bId: String(booking.bId),
//   //         status: "IP",
//   //       },
//   //     ];
//   //     await postForkBookingForDriver(payload);

//   //     await PostRequestedstatus([{
//   //     reqId: String(reqId),
//   //     status: "IP",  // Same status as postForkBookingForDriver
//   //     booking_end_time: null
//   //   }]);


//   //     // Send WebSocket update
//   //     bookingWS.sendStatusUpdate({
//   //       bId: booking.bId,
//   //       status: "IP",
//   //       dlatitude: driverLocation?.latitude,
//   //       dlongitude: driverLocation?.longitude,
//   //       vId: booking.vId,
//   //       dSNo: userDetails?.ServiceNo,
//   //     });

//   //     // Update local state
//   //     setBooking(updatedBooking);
//   //     setTripStage("trip_started");
//   //     initializeHireBubble(updatedBooking);
      
//   //     toast.success("✅ Trip started! Heading to destination");
//   //   } catch (err) {
//   //     console.error("[DriverTrip] Failed to start trip:", err);
//   //     toast.error("Failed to update status. Please try again.");
//   //   }
//   // };


//   const handleArrivedAtPickup = async () => {
//   try {
//     if (!booking?.bId) {
//       toast.error("No booking loaded");
//       return;
//     }

//     console.log("[DriverTrip] Step 1: Updating booking status to IP...");
//     // First: Update booking status via postForkBookingForDriver
//     const payload = [{
//       bId: String(booking.bId),
//       status: "IP",
//     }];
//     await postForkBookingForDriver(payload);
//     console.log("[DriverTrip] ✓ postForkBookingForDriver completed");

//     console.log("[DriverTrip] Step 2: Fetching reqId...");
//     // Second: Get reqId from main fork booking details
//     const reqId = await fetchReqIdForBooking(booking.bId, passedReqId);
//     console.log("[DriverTrip] ✓ Got reqId:", reqId);

//     console.log("[DriverTrip] Step 3: Updating requested status...");
//     // Third: Update requested status with the reqId
//     await PostRequestedstatus([{
//       reqId: String(reqId),
//       status: "IP",
//       booking_end_time: null
//     }]);
//     console.log("[DriverTrip] ✓ PostRequestedstatus completed");

//     // Send WebSocket update
//     bookingWS.sendStatusUpdate({
//       bId: booking.bId,
//       status: "IP",
//       dlatitude: driverLocation?.latitude,
//       dlongitude: driverLocation?.longitude,
//       vId: booking.vId,
//       dSNo: userDetails?.ServiceNo,
//     });

//     // Update local state
//     const updatedBooking = {
//       ...booking,
//       status: "IP",
//     };
//     setBooking(updatedBooking);
//     setTripStage("trip_started");
//     initializeHireBubble(updatedBooking);
    
//     toast.success("✅ Trip started! Heading to destination");
//   } catch (err) {
//     console.error("[DriverTrip] Failed to start trip:", err);
//     toast.error("Failed to update status. Please try again.");
//   }
// };


//   const handleStartTrip = async () => {
//     try {
//       if (!booking?.bId) {
//         toast.error("No booking loaded");
//         return;
//       }

//       // Status is already IP from handleArrivedAtPickup
//       // This is just a button confirmation, no status change needed
//       toast.info("✓ Trip already started");
//       setTripStage("trip_started");
//     } catch (err) {
//       console.error("[DriverTrip] Failed to confirm trip start:", err);
//       toast.error("Failed to confirm. Please try again.");
//     }
//   };

//   // const handleCompleteTrip = async () => {
//   //   try {
//   //     if (!booking?.bId) {
//   //       toast.error("No booking loaded");
//   //       return;
//   //     }

//   //      const reqId = await fetchReqIdForBooking(booking.bId);

//   //     // Update booking status to C (Completed) via API
//   //     const now = new Date();
//   //     const isoDate = now.toISOString().slice(0, 10);
//   //     const timeStr = now.toTimeString().slice(0, 8);
//   //     const completionTime = `${isoDate} ${timeStr}`;

//   //     const updatedBooking = {
//   //       ...booking,
//   //       status: "CO", // Completed
//   //       beTime: completionTime,
//   //     };

//   //     const payload = [
//   //       {
//   //         bId: String(booking.bId),
//   //         status: "CO",
//   //         beTime: completionTime,
//   //       },
//   //     ];
//   //     await postForkBookingForDriver(payload);

//   //     await PostRequestedstatus([{
//   //     reqId: String(reqId),
//   //     status: "CO",  // Same status as postForkBookingForDriver
//   //     booking_end_time: completionTime
//   //   }]);


//   //     // Send WebSocket update
//   //     bookingWS.sendStatusUpdate({
//   //       bId: booking.bId,
//   //       status: "CO",
//   //       dlatitude: driverLocation?.latitude,
//   //       dlongitude: driverLocation?.longitude,
//   //       vId: booking.vId,
//   //       dSNo: userDetails?.ServiceNo,
//   //       beTime: completionTime,
//   //     });

//   //     // Update local state
//   //     setBooking(updatedBooking);
//   //     setTripStage("completed");
//   //     initializeHireBubble(updatedBooking);

//   //     // Clear vehicle bStatus so it's available again
//   //     await resetVehicleBStatus();
      
//   //     toast.success("✅ Trip completed! Thank you.");
      
//   //     // Redirect after short delay
//   //     setTimeout(() => {
//   //       navigate("/driver/dashboard");
//   //     }, 2000);
//   //   } catch (err) {
//   //     console.error("[DriverTrip] Failed to complete trip:", err);
//   //     toast.error("Failed to complete trip. Please try again.");
//   //   }
//   // };

//   const handleCompleteTrip = async () => {
//   try {
//     if (!booking?.bId) {
//       toast.error("No booking loaded");
//       return;
//     }

//     // Create completion timestamp
//     const now = new Date();
//     const isoDate = now.toISOString().slice(0, 10);
//     const timeStr = now.toTimeString().slice(0, 8);
//     const completionTime = `${isoDate} ${timeStr}`;

//     console.log("[DriverTrip] Step 1: Updating booking status to CO...");
//     // First: Update booking status via postForkBookingForDriver
//     const payload = [{
//       bId: String(booking.bId),
//       status: "CO",
//       beTime: completionTime,
//     }];
//     await postForkBookingForDriver(payload);
//     console.log("[DriverTrip] ✓ postForkBookingForDriver completed");

//     console.log("[DriverTrip] Step 2: Fetching reqId...");
//     // Second: Get reqId from main fork booking details
//     const reqId = await fetchReqIdForBooking(booking.bId, passedReqId);
//     console.log("[DriverTrip] ✓ Got reqId:", reqId);

//     console.log("[DriverTrip] Step 3: Updating requested status...");
//     // Third: Update requested status with the reqId and completion time
//     await PostRequestedstatus([{
//       reqId: String(reqId),
//       status: "CO",
//       booking_end_time: completionTime
//     }]);
//     console.log("[DriverTrip] ✓ PostRequestedstatus completed");

//     // Send WebSocket update
//     bookingWS.sendStatusUpdate({
//       bId: booking.bId,
//       status: "CO",
//       dlatitude: driverLocation?.latitude,
//       dlongitude: driverLocation?.longitude,
//       vId: booking.vId,
//       dSNo: userDetails?.ServiceNo,
//       beTime: completionTime,
//     });

//     // Update local state
//     const updatedBooking = {
//       ...booking,
//       status: "CO",
//       beTime: completionTime,
//     };
//     setBooking(updatedBooking);
//     setTripStage("completed");
//     initializeHireBubble(updatedBooking);

//     // Clear vehicle bStatus so it's available again
//     await resetVehicleBStatus();
    
//     toast.success("✅ Trip completed! Thank you.");
    
//     // Redirect after short delay
//     setTimeout(() => {
//       navigate("/driver/dashboard");
//     }, 2000);
//   } catch (err) {
//     console.error("[DriverTrip] Failed to complete trip:", err);
//     toast.error("Failed to complete trip. Please try again.");
//   }
// };

//   // Initial load - ALWAYS fetch from API for fresh data
//   useEffect(() => {
//     if (!bookingId) {
//       setLoadError("No booking ID provided");
//       setIsLoading(false);
//       return;
//     }

//     const loadBooking = async () => {
//       try {
//         setIsLoading(true);
//         setLoadError(null);
        
//         console.log(`[DriverTrip] Fetching booking details for bId: ${bookingId}`);
//         const b = await getLatestBookingById(bookingId);
//         if (b) {
//           console.log("[DriverTrip] Booking found - bId:", b.bId, "Status:", b.status, "vId:", b.vId);
//           setBooking(b);

//           try {
//             const vehicle = await getVehicleById(b.vId);
//             if (vehicle?.vehicleType) {
//               console.log("[DriverTrip] Vehicle type found:", vehicle.vehicleType);
//               setVehicleType(vehicle.vehicleType);
//             }
//           } catch (vErr) {
//             console.error("[DriverTrip] Failed to fetch vehicle type:", vErr);
//           }

//           const stage = determineInitialTripStage(b);
//           console.log("[DriverTrip] Setting tripStage to:", stage);
//           setTripStage(stage);
//           initializeHireBubble(b);
//           fetchEmployeePhoneNumber(b.bookingSno || b.BookingSno);
//           setIsLoading(false);
//         } else {
//           setLoadError(`Booking #${bookingId} not found`);
//           setIsLoading(false);
//         }
//       } catch (err) {
//         console.error("[DriverTrip] Failed to fetch booking:", err);
//         setLoadError("Failed to load trip details");
//         setIsLoading(false);
//       }

//       // Connect Chat WebSocket for Emergency Alerts
//       if (authKey && userDetails?.ServiceNo) {
//         chatWS.connect(authKey, userDetails.ServiceNo, "Driver");
//       }
//     };

//     loadBooking();
//   }, [bookingId, authKey, userDetails?.ServiceNo]);

//   // Get initial location
//   useEffect(() => {
//     const getInitialLocation = async () => {
//       const loc = await getCurrentLocation();
//       if (loc) setDriverLocation(loc);
//     };
//     getInitialLocation();
//   }, []);

//   // Start location updates and load routes
//   useEffect(() => {
//     // Initialize hire bubble when booking is loaded
//     if (booking) {
//       initializeHireBubble(booking);
//     }
//   }, [booking, tripStage]);
//   useEffect(() => {
//     if (!booking || !driverLocation) return;

//     loadRoutes();
//     // Update every 15 seconds to match locationWS automatic interval (prevents duplicate updates)
//     locationInterval.current = setInterval(updateDriverLocation, 15000);

//     // Connect location WebSocket
//     if (authKey) {
//       locationWS.connect(authKey, {
//         vehicleId: booking.vId,
//         driverSno: userDetails?.ServiceNo,
//         driverName: userDetails?.Name,
//         latitude: driverLocation.latitude,
//         longitude: driverLocation.longitude,
//         status: "Active",
//         bStatus: "Booking",
//         oStatus: "O",
//       });
//     }

//     return () => {
//       if (locationInterval.current) clearInterval(locationInterval.current);
//     };
//   }, [booking, driverLocation?.latitude]);

//   // Subscribe to tracking WebSocket to reflect server-side live location
//   useEffect(() => {
//     if (!booking?.vId || !authKey) return;

//     // Ensure tracking WS connected
//     trackingWS.connect(authKey);

//     const unsubscribe = trackingWS.subscribe(booking.vId, (msg) => {
//       if (msg && msg.latitude != null && msg.longitude != null) {
//         setDriverLocation({ latitude: msg.latitude, longitude: msg.longitude });
//       }
//     });

//     return () => {
//       if (unsubscribe) unsubscribe();
//     };
//   }, [booking?.vId, authKey]);

//   // 🔴 Listen for booking cancellation from employee (Active/En Route stages)
//   // Uses SAME pattern as DriverDashboard which is already working
//   useEffect(() => {
//     if (!booking?.bId || !authKey || !userDetails?.ServiceNo) return;

//     console.log("[DriverTrip] 🔌 Connecting to bookingWS for cancellation listening...");
    
//     // Connect to booking WebSocket (same as DriverDashboard does)
//     bookingWS.connect(authKey, userDetails.ServiceNo, booking.vId);

//     // Listen for cancellation - SAME pattern as DriverDashboard
//     bookingWS.onNewBooking((msg) => {
//       console.log("[DriverTrip] 📥 Received booking message:", msg);
//       // Only show toast if this driver is the dSNo
//       if (
//         msg.dSNo && userDetails?.ServiceNo &&
//         msg.dSNo.toString() !== userDetails.ServiceNo.toString()
//       ) {
//         return; // Not for this driver
//       }
//       // Check if this is a cancellation message
//       if (msg.type === "booking_cancelled" || msg.action === "booking_cancelled") {
//         // Check if it's for THIS booking
//         if (msg.bId?.toString() === booking.bId?.toString()) {
//           console.log("[DriverTrip] 🚫 THIS booking cancelled by employee! bId:", msg.bId);
//           // Show toast
//           toast.error("🚫 Hire cancelled by employee!", {
//             position: "top-center",
//             autoClose: 4000,
//           });
//           // Clear vehicle bStatus
//           resetVehicleBStatus();
//           // Redirect to dashboard after short delay
//           setTimeout(() => {
//             navigate("/driver/dashboard");
//           }, 1500);
//         }
//       }
//     });

//     return () => {
//       bookingWS.onNewBooking(null);
//     };
//   }, [booking?.bId, booking?.vId, authKey, userDetails?.ServiceNo, navigate]);

//   // 🔴 NEW: Prevent page refresh during active trip stages
//   useEffect(() => {
//     const handleBeforeUnload = (e) => {
//       // Check if trip is in active stages (not completed or cancelled)
//       const isActiveTrip = booking && 
//         tripStage !== "completed" && 
//         booking.status !== "C" && 
//         booking.status !== "CANCELLED";

//       if (isActiveTrip) {
//         e.preventDefault();
//         e.returnValue = "You have an active trip in progress. Are you sure you want to leave? This may affect the trip status.";
//         return e.returnValue;
//       }
//     };

//     // Add event listener
//     window.addEventListener("beforeunload", handleBeforeUnload);

//     // Cleanup
//     return () => {
//       window.removeEventListener("beforeunload", handleBeforeUnload);
//     };
//   }, [booking, tripStage]);

//   // 🔴 NEW: Loading state UI
//   if (isLoading) {
//     return (
//       <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-900 to-purple-900">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white mx-auto mb-4"></div>
//           <div className="text-3xl font-bold text-white">Loading Trip...</div>
//           <p className="text-white/70 mt-2">Fetching latest booking data</p>
//         </div>
//       </div>
//     );
//   }

//   // 🔴 NEW: Error state UI
//   if (loadError) {
//     return (
//       <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-900 to-purple-900">
//         <div className="text-center bg-white/10 backdrop-blur-lg p-8 rounded-3xl max-w-md">
//           <div className="text-6xl mb-4">❌</div>
//           <p className="text-xl font-bold text-red-400">{loadError}</p>
//           <p className="text-white/70 mt-2">Please try again</p>
//           <div className="flex gap-4 justify-center mt-6">
//             <button 
//               onClick={() => window.location.reload()}
//               className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
//             >
//               🔄 Retry
//             </button>
//             <button 
//               onClick={() => navigate("/driver/dashboard")}
//               className="px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition"
//             >
//               ← Dashboard
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Waiting for location
//   if (!booking || !driverLocation) {
//     return (
//       <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-900 to-purple-900">
//         <div className="text-center">
//           <div className="text-6xl mb-4">🚗</div>
//           <div className="text-3xl font-bold text-white">Getting Location...</div>
//           <p className="text-white/70 mt-2">Please allow location access</p>
//         </div>
//       </div>
//     );
//   }

//   // Validate coordinates with error fallback
//   const pickup = ensureValidLatLng(booking.slatitude, booking.slongitude);
//   const destination = ensureValidLatLng(booking.elatitude, booking.elongitude);
//   const driverPos = [driverLocation.latitude, driverLocation.longitude];

//   const hasValidCoords = !!pickup && !!destination;

//   // Determine which route to show
//   const showPickupRoute = tripStage === "accepted" || tripStage === "heading_to_pickup";
//   const showDestRoute = tripStage === "trip_started" || tripStage === "completed";

//   // Map bounds
//   const mapBounds = hasValidCoords
//     ? (showPickupRoute ? [driverPos, pickup] : [pickup, destination])
//     : [driverPos];

//   return (
//     <div className="flex flex-col min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-purple-900">
//       <DriverHeader driver={{ name: userDetails?.Name || "Driver" }} isOnline={true} toggleOnline={() => {}} />

//       <main className="flex-1 px-4 py-6 max-w-5xl mx-auto w-full space-y-6">

//         {/* BOOKING INFO CARD */}
//         <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 text-white border border-white/20">
//           {!hasValidCoords && (
//             <div className="mb-4 bg-yellow-500/20 border border-yellow-400/40 text-yellow-100 rounded-2xl p-3 text-sm">
//               Coordinates are missing for this scheduled booking. You can still proceed, but route and map pins will appear once coordinates are available.
//             </div>
//           )}
//           <div className="flex items-center justify-between mb-4">
//             <h2 className="text-2xl font-bold">Booking #{booking.bId}</h2>
//             <span className={`px-4 py-2 rounded-full text-sm font-bold ${
//               tripStage === "completed" ? "bg-green-500" :
//               tripStage === "trip_started" ? "bg-blue-500" :
//               "bg-yellow-500 text-yellow-900"
//             }`}>
//               {tripStage === "accepted" && "NEW BOOKING"}
//               {tripStage === "heading_to_pickup" && "HEADING TO PICKUP"}
//               {tripStage === "trip_started" && "ON TRIP"}
//               {tripStage === "completed" && "COMPLETED"}
//             </span>
//           </div>

//           {/* Employee Info */}
//           <div className="bg-white/10 rounded-2xl p-4 mb-4">
//             <p className="text-sm text-white/70">Requested by</p>
//             <p className="text-xl font-bold">{booking.employeeName || "Employee"}</p>
//             {booking.bookingSno && <p className="text-sm text-white/60">ID: {booking.bookingSno}</p>}
//           </div>

//           {/* From - To */}
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div className="bg-green-500/20 rounded-2xl p-4 border-l-4 border-green-500">
//               <p className="text-sm text-green-300 font-medium">📍 PICKUP LOCATION</p>
//               <p className="text-lg font-bold mt-1">
//                 {pickup
//                   ? `${pickup[0].toFixed(4)}, ${pickup[1].toFixed(4)}`
//                   : (getDisplayLocations(booking).from || "N/A")}
//               </p>
//               {distanceToPickup && (
//                 <p className="text-sm text-green-300 mt-1">{distanceToPickup ? Number(distanceToPickup).toFixed(2) : "..."} km away</p>
//               )}
//             </div>
//             <div className="bg-red-500/20 rounded-2xl p-4 border-l-4 border-red-500">
//               <p className="text-sm text-red-300 font-medium">🎯 DESTINATION</p>
//               <p className="text-lg font-bold mt-1">
//                 {destination
//                   ? `${destination[0].toFixed(4)}, ${destination[1].toFixed(4)}`
//                   : (getDisplayLocations(booking).to || "N/A")}
//               </p>
//               {booking.totalDestence && (
//                 <p className="text-sm text-red-300 mt-1">Trip: {booking.totalDestence ? Number(booking.totalDestence).toFixed(2) : "..."} km</p>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* MAP - Responsive */}
//         <div className="bg-white rounded-3xl shadow-2xl overflow-hidden" style={{ height: "300px", position: "relative", zIndex: "auto" }} onLoad={() => window.dispatchEvent(new Event('resize'))}>
//           <style>{`
//             .leaflet-container { z-index: 1 !important; }
//             .leaflet-popup { z-index: 2 !important; }
//             .leaflet-control { z-index: 2 !important; }
//           `}</style>
//           <MapContainer
//             center={driverPos}
//             zoom={14}
//             style={{ height: "100%", width: "100%", zIndex: 1 }}
//           >
//             <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
//             {hasValidCoords && mapBounds.length >= 2 && <FitBounds bounds={mapBounds} />}

//             {/* Driver Marker */}
//             <Marker position={driverPos} icon={getVehicleIcon(vehicleType)}>
//               <Popup>
//                 <strong>🚗 You are here</strong><br />
//                 {booking.vId}
//               </Popup>
//             </Marker>

//             {/* Pickup Marker */}
//             {hasValidCoords && pickup && (
//               <Marker position={pickup} icon={pickupIcon}>
//                 <Popup>
//                   <strong>📍 Pickup Location</strong><br />
//                   {distanceToPickup} km away
//                 </Popup>
//               </Marker>
//             )}

//             {/* Destination Marker (show after trip started) */}
//             {hasValidCoords && (tripStage === "trip_started" || tripStage === "completed") && destination && (
//               <Marker position={destination} icon={destinationIcon}>
//                 <Popup>
//                   <strong>🎯 Destination</strong><br />
//                   {booking.totalDestence ? Number(booking.totalDestence).toFixed(2) : "..."} km trip
//                 </Popup>
//               </Marker>
//             )}

//             {/* Route to Pickup (blue dashed) */}
//             {hasValidCoords && showPickupRoute && routeToPickup.length > 0 && (
//               <Polyline 
//                 positions={routeToPickup} 
//                 color="#3b82f6" 
//                 weight={6} 
//                 opacity={0.9}
//                 dashArray="10, 10"
//               />
//             )}

//             {/* Route to Destination (red solid) */}
//             {hasValidCoords && showDestRoute && routeToDestination.length > 0 && (
//               <Polyline 
//                 positions={routeToDestination} 
//                 color="#ef4444" 
//                 weight={6} 
//                 opacity={0.9}
//               />
//             )}
//           </MapContainer>
//         </div>

//         {/* ACTION BUTTONS */}
//         <div className="space-y-4">
//           {tripStage === "accepted" && (
//             <button
//               onClick={handleStartToPickup}
//               className="w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white py-6 rounded-2xl font-bold text-2xl shadow-2xl transition transform hover:scale-[1.02] flex items-center justify-center gap-3"
//             >
//               <span className="text-3xl">🚀</span>
//               START - Head to Pickup
//             </button>
//           )}

//           {tripStage === "heading_to_pickup" && (
//             <div className="space-y-4">
//               <CallEmployeeButton
//                 employeeName={booking.employeeName || "Employee"}
//                 employeePhone={employeePhoneNumber}
//                 showSMS={true}
//                 className="w-full"
//                 buttonSize="md"
//               />
//               <button
//                 onClick={handleArrivedAtPickup}
//                 className="w-full bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white py-6 rounded-2xl font-bold text-2xl shadow-2xl transition transform hover:scale-[1.02] flex items-center justify-center gap-3"
//               >
//                 <span className="text-3xl">📍</span>
//                 I'VE ARRIVED at Pickup
//               </button>
//             </div>
//           )}

//           {tripStage === "trip_started" && (
//             <div className="space-y-4">
//               <CallEmployeeButton
//                 employeeName={booking.employeeName || "Employee"}
//                 employeePhone={employeePhoneNumber}
//                 showSMS={true}
//                 className="w-full"
//                 buttonSize="md"
//               />
//               <button
//                 onClick={handleCompleteTrip}
//                 className="w-full bg-gradient-to-r from-purple-500 to-pink-600 hover:from-purple-600 hover:to-pink-700 text-white py-6 rounded-2xl font-bold text-2xl shadow-2xl transition transform hover:scale-[1.02] flex items-center justify-center gap-3"
//               >
//                 <span className="text-3xl">✅</span>
//                 COMPLETE TRIP
//               </button>
//             </div>
//           )}

//           {tripStage === "completed" && (
//             <div className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-6 rounded-2xl font-bold text-2xl text-center shadow-2xl animate-pulse">
//               <span className="text-3xl mr-2">🎉</span>
//               TRIP COMPLETED SUCCESSFULLY!
//             </div>
//           )}
//         </div>

//         {/* Distance Info Bar */}
//         {tripStage !== "completed" && (
//           <div className="bg-white/10 backdrop-blur rounded-2xl p-4 flex justify-around text-white text-center">
//             <div>
//               <p className="text-sm text-white/70">To Pickup</p>
//               <p className="text-2xl font-bold">{distanceToPickup ? Number(distanceToPickup).toFixed(2) : "..."} km</p>
//             </div>
//             <div className="border-l border-white/20 pl-8">
//               <p className="text-sm text-white/70">Trip Distance</p>
//               <p className="text-2xl font-bold">{booking.totalDestence ? Number(booking.totalDestence).toFixed(2) : "..."} km</p>
//             </div>
//           </div>
//         )}
//       </main>

//       <DriverFooter />

//       {/* Hire Assistance Bubble - Google Maps Navigation (EN and IP stages only) */}
//       {pickup && destination && (
//         <HireAssistanceBubble
//           tripStage={tripStage}
//           pickupLocation={pickup ? {
//             lat: pickup[0],
//             lng: pickup[1],
//           } : null}
//           destinationLocation={destination ? {
//             lat: destination[0],
//             lng: destination[1],
//           } : null}
//           driverLocation={driverLocation ? {
//             lat: driverLocation.latitude,
//             lng: driverLocation.longitude,
//           } : null}
//           onEmergency={handleOpenEmergency}
//         />
//       )}

//       <EmergencyAlertModal
//         isOpen={isEmergencyModalOpen}
//         onClose={() => setIsEmergencyModalOpen(false)}
//         onSend={handleSendEmergency}
//         isSending={isSendingEmergency}
//       />
//     </div>
//   );
// };

// export default DriverTrip;







import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { defaultUserImg } from "../assets/defaultUser";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Import vehicle icons
import carIcon from "../assets/car.png";
import vanIcon from "../assets/van.png";
import busIcon from "../assets/bus.png";
import lorryIcon from "../assets/lorry.png";
import suvIcon from "../assets/suv.png";
import cabIcon from "../assets/cab.png";
import forkliftIcon from "../assets/fork lift.png";
import dockyardIcon from "../assets/dockyard.png";
import cherryIcon from "../assets/cherry.png";
import craneIcon from "../assets/crane.jpg";
import DriverHeader from "../components/DriverHeader";
import DriverFooter from "../components/DriverFooter";
import CallEmployeeButton from "../components/CallEmployeeButton";
import HireAssistanceBubble from "../components/HireAssistanceBubble";
import { useDispatch, useSelector } from "react-redux";
import api from "../services/api";
import { calculateDistance, estimateETA, calculateFare } from "../services/mapsService";
import locationWS from "../services/locationWebSocket";
import trackingWS from "../services/trackingWebSocket";
import bookingWS from "../services/bookingWebSocket";
import chatWS from "../services/chatWebSocket";
import EmergencyAlertModal from "../components/EmergencyAlertModal";
import { updateEmergency } from "../services/vehicleService";
import { fetchBookings } from "../actions/BookingActions";
import { fetchUsers } from "../actions/UserActions";
import { fetchVehicles } from "../actions/VehicleActions";
import { getForkBookingDetails, postForkBookingForDriver, PostRequestedstatus, getMainForkBookingDetailsbid } from "../services/bookingService";

// Fix Leaflet icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// Helper to validate and parse coordinates
const parseCoordinate = (value) => {
  const parsed = parseFloat(value);
  return !isNaN(parsed) ? parsed : null;
};

// Helper to ensure valid LatLng array
const ensureValidLatLng = (lat, lng) => {
  const validLat = parseCoordinate(lat);
  const validLng = parseCoordinate(lng);
  if (validLat !== null && validLng !== null) {
    return [validLat, validLng];
  }
  return null;
};

// Function to get vehicle icon based on type
const getVehicleIcon = (vehicleType) => {
  const type = vehicleType?.toUpperCase()?.trim() || "C";
  let iconUrl = carIcon;
  
  if (type === "V" || type.includes("VAN")) iconUrl = vanIcon;
  else if (type === "B" || type.includes("BUS")) iconUrl = busIcon;
  else if (type === "L" || type.includes("LORRY") || type.includes("TRUCK")) iconUrl = lorryIcon;
  else if (type === "S" || type.includes("SUV")) iconUrl = suvIcon;
  else if (type === "CA" || type.includes("CAB") || type.includes("TAXI")) iconUrl = cabIcon;
  else if (type === "F" || type.includes("FORKLIFT") || type.includes("FORK")) iconUrl = forkliftIcon;
  else if (type.includes("DOCKYARD")) iconUrl = dockyardIcon;
  else if (type === "CH" || type.includes("CHERRY")) iconUrl = cherryIcon;
  else if (type === "CR" || type.includes("CRANE")) iconUrl = craneIcon;
  else if (type === "C" || type.includes("CAR")) iconUrl = carIcon;
  
  return new L.Icon({
    iconUrl: iconUrl,
    iconSize: [45, 45],
    iconAnchor: [22, 45],
    popupAnchor: [0, -45],
  });
};

const pickupIcon = new L.Icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
  iconSize: [40, 40],
  iconAnchor: [20, 40],
  popupAnchor: [0, -40],
});

const destinationIcon = new L.Icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/149/149060.png",
  iconSize: [40, 40],
  iconAnchor: [20, 40],
  popupAnchor: [0, -40],
});

// Map auto-fit to show all points
const FitBounds = ({ bounds }) => {
  const map = useMap();
  const hasFitted = useRef(false);

  useEffect(() => {
    if (bounds && bounds.length >= 2 && !hasFitted.current) {
      map.fitBounds(bounds, { padding: [50, 50], maxZoom: 15 });
      hasFitted.current = true;
    }
  }, [bounds, map]);
  return null;
};

// Fetch route from OpenRouteService
const fetchRoute = async (start, end) => {
  const apiKey = process.env.REACT_APP_ORS_KEY;
  if (!apiKey) return null;
  try {
    const url = `https://api.openrouteservice.org/v2/directions/driving-car?api_key=${apiKey}&start=${start[1]},${start[0]}&end=${end[1]},${end[0]}`;
    const res = await fetch(url);
    const data = await res.json();
    const coords = data.features?.[0]?.geometry?.coordinates;
    if (coords) {
      return coords.map(([lng, lat]) => [lat, lng]);
    }
  } catch (e) {
    console.error("Route fetch error:", e);
  }
  return null;
};

const DriverTrip = () => {
  const dispatch = useDispatch();
  const getBookings = async () => dispatch(fetchBookings());
  const getUsers = async () => dispatch(fetchUsers());
  const getVehicles = async () => dispatch(fetchVehicles());
  const { authKey, userDetails } = useSelector((state) => state.auth);
  const { bookingId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const passedReqId = location.state?.reqId || null;

  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);
  const [booking, setBooking] = useState(null);
  const [vehicleType, setVehicleType] = useState("C");
  const [tripStage, setTripStage] = useState("accepted");
  const [driverLocation, setDriverLocation] = useState(null);
  const [routeToPickup, setRouteToPickup] = useState([]);
  const [routeToDestination, setRouteToDestination] = useState([]);
  const [distanceToPickup, setDistanceToPickup] = useState(null);
  const [distanceToDestination, setDistanceToDestination] = useState(null);
  const [employeePhoneNumber, setEmployeePhoneNumber] = useState(null);
  const [activeHire, setActiveHire] = useState(null);
  const [hireStage, setHireStage] = useState('accepted');
  const [isEmergencyModalOpen, setIsEmergencyModalOpen] = useState(false);
  const [isSendingEmergency, setIsSendingEmergency] = useState(false);
  const lastRouteRefresh = useRef(0);
  const locationInterval = useRef(null);

  const getLatestBookingById = async (id) => {
    const allBookings = await getBookings();
    const found = allBookings.find((b) => b.bId?.toString() === id?.toString()) || null;
    if (found && (found.bsTime || found.beTime)) return found;

    try {
      const forkDetails = await getForkBookingDetails(id);
      if (Array.isArray(forkDetails) && forkDetails[0]) {
        return { ...found, ...forkDetails[0] };
      }
      if (forkDetails && typeof forkDetails === "object") {
        return { ...found, ...forkDetails };
      }
    } catch (err) {
      console.warn("[DriverTrip] Failed to load fork booking details:", err);
    }

    return found;
  };

  const getVehicleById = async (id) => {
    const vehicles = await getVehicles();
    return vehicles.find((v) => v.vehicleId?.toString() === id?.toString()) || null;
  };

  const getEmployeeByServiceNo = async (serviceNo) => {
    const users = await getUsers();
    return users.find((u) => u.ServiceNo?.toString() === serviceNo?.toString()) || null;
  };

  const resolveSubBookingForVehicle = (bookingData) => {
    if (!bookingData) return null;
    const subBookings =
      bookingData.SubBookings ||
      bookingData.subBookings ||
      bookingData.subBooking ||
      bookingData.subBookingDetails ||
      [];
    if (!Array.isArray(subBookings) || subBookings.length === 0) return null;
    const vId = String(bookingData?.vId || "");
    return (
      subBookings.find((sub) => String(sub?.subvid || sub?.subvId || sub?.vId || sub?.vid || "") === vId) ||
      null
    );
  };

  const getDisplayLocations = (bookingData) => {
    if (!bookingData) return { from: "", to: "" };
    const baseFrom = bookingData.From || bookingData.fromLocation || bookingData.WorkArea || "";
    const baseTo = bookingData.TO || bookingData.toLocation || "";
    if (baseFrom || baseTo) return { from: baseFrom, to: baseTo };
    const sub = resolveSubBookingForVehicle(bookingData);
    if (!sub) return { from: "", to: "" };
    const subFrom = sub.subFrom || sub.From || sub.from || "";
    const subTo = sub.subTO || sub.TO || sub.to || "";
    return { from: subFrom || "", to: subTo || "" };
  };

  const determineInitialTripStage = (bookingData) => {
    if (!bookingData) return "accepted";
    const status = bookingData.status?.toUpperCase()?.trim() || "";
    if (status === "A" || status === "ACTIVE") return "accepted";
    else if (status === "EN" || status === "ENROUTE") return "heading_to_pickup";
    else if (status === "IP" || status === "INPROGRESS" || status === "IN PROGRESS") return "trip_started";
    return "accepted";
  };

  const handleOpenEmergency = () => {
    setIsEmergencyModalOpen(true);
  };

  const handleSendEmergency = async ({ ecode, ediscription }) => {
    if (!booking?.vId) {
      toast.error("No vehicle assigned. Cannot send alert.");
      return;
    }

    setIsSendingEmergency(true);
    try {
      await updateEmergency(booking.vId, ecode, ediscription);
      chatWS.sendEmergency({
        vehicleId: booking.vId,
        ecode: ecode,
        ediscription: ediscription,
        driverName: userDetails?.Name || "Driver",
        driverSno: userDetails?.ServiceNo || "",
        mobileNo: "N/A"
      });
      toast.success("EMERGENCY ALERT SENT! Help is on the way.");
      setIsEmergencyModalOpen(false);
    } catch (error) {
      console.error("Emergency Alert Failed:", error);
      toast.error("Failed to send alert! Please call emergency services.");
    } finally {
      setIsSendingEmergency(false);
    }
  };

  const getCurrentLocation = () => {
    return new Promise((resolve) => {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            resolve({
              latitude: parseFloat(pos.coords.latitude.toFixed(6)),
              longitude: parseFloat(pos.coords.longitude.toFixed(6)),
            });
          },
          () => resolve(driverLocation),
          { enableHighAccuracy: true, timeout: 10000 }
        );
      } else {
        resolve(driverLocation);
      }
    });
  };

  const haversineDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = Math.sin(dLat/2) ** 2 + Math.cos(lat1 * Math.PI/180) * Math.cos(lat2 * Math.PI/180) * Math.sin(dLon/2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  const initializeHireBubble = (bookingData) => {
    if (!bookingData) return;
    const pickup = ensureValidLatLng(bookingData.slatitude, bookingData.slongitude);
    const destination = ensureValidLatLng(bookingData.elatitude, bookingData.elongitude);
    if (!pickup || !destination) return;
    const distance = calculateDistance(
      { lat: pickup[0], lng: pickup[1] },
      { lat: destination[0], lng: destination[1] }
    );
    const eta = estimateETA(distance);
    const fare = calculateFare(distance);
    setActiveHire({
      hireId: bookingData.bId,
      bookingId: bookingData.bId,
      status: tripStage,
      pickupLocation: { lat: pickup[0], lng: pickup[1] },
      destinationLocation: { lat: destination[0], lng: destination[1] },
      distance: distance,
      eta: eta,
      fare: fare,
    });
    setHireStage(tripStage);
  };

  const updateDriverLocation = async () => {
    const loc = await getCurrentLocation();
    if (!loc) return;
    setDriverLocation(loc);
    if (booking) {
      const pickup = ensureValidLatLng(booking.slatitude, booking.slongitude);
      const dest = ensureValidLatLng(booking.elatitude, booking.elongitude);
      if (pickup) {
        {/* MODIFIED BY SANUPA: Changed .toFixed(1) to .toFixed(3) */}
        setDistanceToPickup(haversineDistance(loc.latitude, loc.longitude, pickup[0], pickup[1]).toFixed(3));
      }
      if (dest) {
        setDistanceToDestination(haversineDistance(loc.latitude, loc.longitude, dest[0], dest[1]).toFixed(3));
      }
    }
    if (booking?.vId) {
      try {
        const payload = [{
          vehicleId: booking.vId,
          status: "A",
          latitude: loc.latitude,
          longitude: loc.longitude,
        }];
        await api.post("/VehicleRegister/UpdateVehicleLocation", payload);
        if (locationWS.isReady()) {
          locationWS.updateDriverData({
            latitude: loc.latitude,
            longitude: loc.longitude,
            bStatus: "B",
          });
        }
      } catch (err) {
        console.error("Location update failed", err);
      }
    }
  };

  const resetVehicleBStatus = async () => {
    if (!booking?.vId) return;
    const loc = await getCurrentLocation();
    let vehicle = null;
    try {
      vehicle = await getVehicleById(booking.vId);
    } catch (err) {
      console.error("Failed to fetch vehicle before reset bStatus:", err);
    }
    const typeCodeMap = {
      Car: "C", Van: "V", Lorry: "L", SUV: "S", Cab: "CA",
      Bus: "B", "Cherry Picker": "CH", Forklift: "F", Crane: "CR", Trailer: "T",
    };
    const vehicleTypeCode = typeCodeMap[vehicle?.vehicleType] || vehicle?.vehicleType || "C";
    const statusCode = vehicle?.status === "Inactive" ? "I" : "A";
    const oStatusValue = "O";
    const payload = [{
      vehicleId: vehicle?.vehicleId || booking.vId,
      vehicleType: vehicleTypeCode,
      weightCat: vehicle?.weightCat || "",
      driverSno: vehicle?.driverSno || userDetails?.ServiceNo || "",
      status: statusCode,
      bStatus: "",
      oStatus: oStatusValue,
      latitude: loc?.latitude ?? vehicle?.latitude ?? "",
      longitude: loc?.longitude ?? vehicle?.longitude ?? "",
    }];
    try {
      await api.post("/VehicleRegister/PostVehicleDetails", payload);
      console.log("Reset bStatus to empty for vehicle", booking.vId);
      locationWS.updateDriverData({
        vehicleId: vehicle?.vehicleId || booking.vId,
        vehicle_type: vehicle?.vehicleType || "Car",
        vehicleType: vehicle?.vehicleType || "Car",
        latitude: payload[0].latitude,
        longitude: payload[0].longitude,
        bStatus: "",
        oStatus: "O",
        status: statusCode,
      });
      if (locationWS.isReady()) {
        locationWS.sendLocationUpdate();
      }
    } catch (err) {
      console.error("Failed to reset vehicle bStatus:", err);
    }
  };

  const fetchReqIdForBooking = async (bId, passedReqId = null) => {
    if (passedReqId) {
      return String(passedReqId);
    }
    try {
      const response = await getMainForkBookingDetailsbid(bId);
      let reqId = null;
      if (response && Array.isArray(response)) {
        if (response.length > 0) {
          reqId = response[0]?.reqId || response[0]?.ReqId;
        }
      } else if (response?.data) {
        if (Array.isArray(response.data)) {
          reqId = response.data[0]?.reqId || response.data[0]?.ReqId;
        } else if (response.data.reqId || response.data.ReqId) {
          reqId = response.data.reqId || response.data.ReqId;
        }
      } else if (response?.reqId || response?.ReqId) {
        reqId = response.reqId || response.ReqId;
      } else if (response?.resultSet && Array.isArray(response.resultSet) && response.resultSet.length > 0) {
        reqId = response.resultSet[0]?.reqId || response.resultSet[0]?.ReqId;
      }
      if (!reqId) {
        return String(bId);
      }
      return String(reqId);
    } catch (err) {
      return String(bId);
    }
  };

  const loadRoutes = async () => {
    if (!booking || !driverLocation) return;
    const pickup = ensureValidLatLng(booking.slatitude, booking.slongitude);
    const dest = ensureValidLatLng(booking.elatitude, booking.elongitude);
    if (!pickup || !dest) return;
    const driver = [driverLocation.latitude, driverLocation.longitude];
    const toPickup = await fetchRoute(driver, pickup);
    if (toPickup) setRouteToPickup(toPickup);
    const toDest = await fetchRoute(pickup, dest);
    if (toDest) setRouteToDestination(toDest);
  };

  const fetchEmployeePhoneNumber = async (employeeServiceNo) => {
    if (!employeeServiceNo) {
      setEmployeePhoneNumber(null);
      return;
    }
    try {
      const employee = await getEmployeeByServiceNo(employeeServiceNo);
      if (employee && employee.MobileNo) {
        setEmployeePhoneNumber(employee.MobileNo);
      } else {
        setEmployeePhoneNumber(null);
      }
    } catch (err) {
      console.error("Failed to fetch employee phone number:", err);
      setEmployeePhoneNumber(null);
    }
  };

  const handleStartToPickup = async () => {
    try {
      if (!booking?.bId) {
        toast.error("No booking loaded");
        return;
      }
      const payload = [{
        bId: String(booking.bId),
        status: "EN",
      }];
      await postForkBookingForDriver(payload);
      const reqId = await fetchReqIdForBooking(booking.bId, passedReqId);
      await PostRequestedstatus([{
        reqId: String(reqId),
        status: "EN",
        booking_end_time: null
      }]);
      bookingWS.sendStatusUpdate({
        bId: booking.bId,
        status: "EN",
        dlatitude: driverLocation?.latitude,
        dlongitude: driverLocation?.longitude,
        vId: booking.vId,
        dSNo: userDetails?.ServiceNo,
      });
      const updatedBooking = { ...booking, status: "EN" };
      setBooking(updatedBooking);
      setTripStage("heading_to_pickup");
      initializeHireBubble(updatedBooking);
      toast.success("✅ Heading to pickup location");
    } catch (err) {
      console.error("[DriverTrip] Failed to start trip:", err);
      toast.error("Failed to update status. Please try again.");
    }
  };

  const handleArrivedAtPickup = async () => {
    try {
      if (!booking?.bId) {
        toast.error("No booking loaded");
        return;
      }
      const payload = [{
        bId: String(booking.bId),
        status: "IP",
      }];
      await postForkBookingForDriver(payload);
      const reqId = await fetchReqIdForBooking(booking.bId, passedReqId);
      await PostRequestedstatus([{
        reqId: String(reqId),
        status: "IP",
        booking_end_time: null
      }]);
      bookingWS.sendStatusUpdate({
        bId: booking.bId,
        status: "IP",
        dlatitude: driverLocation?.latitude,
        dlongitude: driverLocation?.longitude,
        vId: booking.vId,
        dSNo: userDetails?.ServiceNo,
      });
      const updatedBooking = { ...booking, status: "IP" };
      setBooking(updatedBooking);
      setTripStage("trip_started");
      initializeHireBubble(updatedBooking);
      toast.success("✅ Trip started! Heading to destination");
    } catch (err) {
      console.error("[DriverTrip] Failed to start trip:", err);
      toast.error("Failed to update status. Please try again.");
    }
  };

  const handleCompleteTrip = async () => {
    try {
      if (!booking?.bId) {
        toast.error("No booking loaded");
        return;
      }
      const now = new Date();
      const isoDate = now.toISOString().slice(0, 10);
      const timeStr = now.toTimeString().slice(0, 8);
      const completionTime = `${isoDate} ${timeStr}`;
      const payload = [{
        bId: String(booking.bId),
        status: "CO",
        beTime: completionTime,
      }];
      await postForkBookingForDriver(payload);
      const reqId = await fetchReqIdForBooking(booking.bId, passedReqId);
      await PostRequestedstatus([{
        reqId: String(reqId),
        status: "CO",
        booking_end_time: completionTime
      }]);
      bookingWS.sendStatusUpdate({
        bId: booking.bId,
        status: "CO",
        dlatitude: driverLocation?.latitude,
        dlongitude: driverLocation?.longitude,
        vId: booking.vId,
        dSNo: userDetails?.ServiceNo,
        beTime: completionTime,
      });
      const updatedBooking = { ...booking, status: "CO", beTime: completionTime };
      setBooking(updatedBooking);
      setTripStage("completed");
      initializeHireBubble(updatedBooking);
      await resetVehicleBStatus();
      toast.success("✅ Trip completed! Thank you.");
      setTimeout(() => {
        navigate("/driver/dashboard");
      }, 2000);
    } catch (err) {
      console.error("[DriverTrip] Failed to complete trip:", err);
      toast.error("Failed to complete trip. Please try again.");
    }
  };

  // Initial load
  useEffect(() => {
    if (!bookingId) {
      setLoadError("No booking ID provided");
      setIsLoading(false);
      return;
    }
    const loadBooking = async () => {
      try {
        setIsLoading(true);
        setLoadError(null);
        const b = await getLatestBookingById(bookingId);
        if (b) {
          setBooking(b);
          try {
            const vehicle = await getVehicleById(b.vId);
            if (vehicle?.vehicleType) {
              setVehicleType(vehicle.vehicleType);
            }
          } catch (vErr) {
            console.error("[DriverTrip] Failed to fetch vehicle type:", vErr);
          }
          const stage = determineInitialTripStage(b);
          setTripStage(stage);
          initializeHireBubble(b);
          fetchEmployeePhoneNumber(b.bookingSno || b.BookingSno);
          setIsLoading(false);
        } else {
          setLoadError(`Booking #${bookingId} not found`);
          setIsLoading(false);
        }
      } catch (err) {
        console.error("[DriverTrip] Failed to fetch booking:", err);
        setLoadError("Failed to load trip details");
        setIsLoading(false);
      }
      if (authKey && userDetails?.ServiceNo) {
        chatWS.connect(authKey, userDetails.ServiceNo, "Driver");
      }
    };
    loadBooking();
  }, [bookingId, authKey, userDetails?.ServiceNo]);

  // Get initial location
  useEffect(() => {
    const getInitialLocation = async () => {
      const loc = await getCurrentLocation();
      if (loc) setDriverLocation(loc);
    };
    getInitialLocation();
  }, []);

  // Initialize hire bubble when booking is loaded
  useEffect(() => {
    if (booking) {
      initializeHireBubble(booking);
    }
  }, [booking, tripStage]);

  // Location updates and routes
  useEffect(() => {
    if (!booking || !driverLocation) return;
    loadRoutes();
    locationInterval.current = setInterval(updateDriverLocation, 15000);
    if (authKey) {
      locationWS.connect(authKey, {
        vehicleId: booking.vId,
        driverSno: userDetails?.ServiceNo,
        driverName: userDetails?.Name,
        latitude: driverLocation.latitude,
        longitude: driverLocation.longitude,
        status: "Active",
        bStatus: "Booking",
        oStatus: "O",
      });
    }
    return () => {
      if (locationInterval.current) clearInterval(locationInterval.current);
    };
  }, [booking, driverLocation?.latitude]);

  // Subscribe to tracking WebSocket
  useEffect(() => {
    if (!booking?.vId || !authKey) return;
    trackingWS.connect(authKey);
    const unsubscribe = trackingWS.subscribe(booking.vId, (msg) => {
      if (msg && msg.latitude != null && msg.longitude != null) {
        setDriverLocation({ latitude: msg.latitude, longitude: msg.longitude });
      }
    });
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [booking?.vId, authKey]);

  // Listen for booking cancellation from employee
  useEffect(() => {
    if (!booking?.bId || !authKey || !userDetails?.ServiceNo) return;
    console.log("[DriverTrip] 🔌 Connecting to bookingWS for cancellation listening...");
    bookingWS.connect(authKey, userDetails.ServiceNo, booking.vId);
    bookingWS.onNewBooking((msg) => {
      console.log("[DriverTrip] 📥 Received booking message:", msg);
      if (msg.dSNo && userDetails?.ServiceNo &&
          msg.dSNo.toString() !== userDetails.ServiceNo.toString()) {
        return;
      }
      if (msg.type === "booking_cancelled" || msg.action === "booking_cancelled") {
        if (msg.bId?.toString() === booking.bId?.toString()) {
          console.log("[DriverTrip] 🚫 THIS booking cancelled by employee! bId:", msg.bId);
          toast.error("🚫 Hire cancelled by employee!", {
            position: "top-center",
            autoClose: 4000,
          });
          resetVehicleBStatus();
          setTimeout(() => {
            navigate("/driver/dashboard");
          }, 1500);
        }
      }
    });
    return () => {
      bookingWS.onNewBooking(null);
    };
  }, [booking?.bId, booking?.vId, authKey, userDetails?.ServiceNo, navigate]);

  // 🔴 NEW: Listen for booking completion (when admin/employee marks as completed from ScheduledBookingList)
  useEffect(() => {
    if (!booking?.bId || !authKey || !userDetails?.ServiceNo) return;
    console.log("[DriverTrip] 🔌 Setting up completion listener for booking:", booking.bId);
    const unsubscribe = bookingWS.onStatusUpdate((msg) => {
      console.log("[DriverTrip] 📥 Received status update:", msg);
      if (msg.bId?.toString() === booking.bId?.toString()) {
        const status = (msg.status || "").toString().toUpperCase();
        if (status === "CO" || status === "COMPLETED") {
          console.log("[DriverTrip] ✅ THIS booking completed by admin/employee! bId:", msg.bId);
          toast.success("✅ Booking marked as completed!", {
            position: "top-center",
            autoClose: 3000,
          });
          resetVehicleBStatus();
          setTimeout(() => {
            navigate("/driver/dashboard");
          }, 1500);
        }
      }
    });
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [booking?.bId, booking?.vId, authKey, userDetails?.ServiceNo, navigate]);

  // Prevent page refresh during active trip stages
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      const isActiveTrip = booking && 
        tripStage !== "completed" && 
        booking.status !== "C" && 
        booking.status !== "CANCELLED";
      if (isActiveTrip) {
        e.preventDefault();
        e.returnValue = "You have an active trip in progress. Are you sure you want to leave? This may affect the trip status.";
        return e.returnValue;
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [booking, tripStage]);

  // Recompute routes when driver moves
  useEffect(() => {
    const now = Date.now();
    if (!booking || !driverLocation) return;
    if (now - lastRouteRefresh.current < 30000) return;
    lastRouteRefresh.current = now;
    loadRoutes();
  }, [driverLocation?.latitude, driverLocation?.longitude, booking, tripStage]);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-900 to-purple-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white mx-auto mb-4"></div>
          <div className="text-3xl font-bold text-white">Loading Trip...</div>
          <p className="text-white/70 mt-2">Fetching latest booking data</p>
        </div>
      </div>
    );
  }

  if (loadError) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-900 to-purple-900">
        <div className="text-center bg-white/10 backdrop-blur-lg p-8 rounded-3xl max-w-md">
          <div className="text-6xl mb-4">❌</div>
          <p className="text-xl font-bold text-red-400">{loadError}</p>
          <p className="text-white/70 mt-2">Please try again</p>
          <div className="flex gap-4 justify-center mt-6">
            <button onClick={() => window.location.reload()} className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">🔄 Retry</button>
            <button onClick={() => navigate("/driver/dashboard")} className="px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition">← Dashboard</button>
          </div>
        </div>
      </div>
    );
  }

  if (!booking || !driverLocation) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-900 to-purple-900">
        <div className="text-center">
          <div className="text-6xl mb-4">🚗</div>
          <div className="text-3xl font-bold text-white">Getting Location...</div>
          <p className="text-white/70 mt-2">Please allow location access</p>
        </div>
      </div>
    );
  }

  const pickup = ensureValidLatLng(booking.slatitude, booking.slongitude);
  const destination = ensureValidLatLng(booking.elatitude, booking.elongitude);
  const driverPos = [driverLocation.latitude, driverLocation.longitude];
  const hasValidCoords = !!pickup && !!destination;
  const showPickupRoute = tripStage === "accepted" || tripStage === "heading_to_pickup";
  const showDestRoute = tripStage === "trip_started" || tripStage === "completed";
  const mapBounds = hasValidCoords
    ? (showPickupRoute ? [driverPos, pickup] : [pickup, destination])
    : [driverPos];

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-purple-900">
      <DriverHeader driver={{ name: userDetails?.Name || "Driver" }} isOnline={true} toggleOnline={() => {}} />

      <main className="flex-1 px-4 py-6 max-w-5xl mx-auto w-full space-y-6">
        <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-6 text-white border border-white/20">
          {!hasValidCoords && (
            <div className="mb-4 bg-yellow-500/20 border border-yellow-400/40 text-yellow-100 rounded-2xl p-3 text-sm">
              Coordinates are missing for this scheduled booking. You can still proceed, but route and map pins will appear once coordinates are available.
            </div>
          )}
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-2xl font-bold">Booking #{booking.bId}</h2>
            <span className={`px-4 py-2 rounded-full text-sm font-bold ${
              tripStage === "completed" ? "bg-green-500" :
              tripStage === "trip_started" ? "bg-blue-500" :
              "bg-yellow-500 text-yellow-900"
            }`}>
              {tripStage === "accepted" && "NEW BOOKING"}
              {tripStage === "heading_to_pickup" && "HEADING TO PICKUP"}
              {tripStage === "trip_started" && "ON TRIP"}
              {tripStage === "completed" && "COMPLETED"}
            </span>
          </div>

          <div className="bg-white/10 rounded-2xl p-4 mb-4">
            <p className="text-sm text-white/70">Requested by</p>
            <p className="text-xl font-bold">{booking.employeeName || "Employee"}</p>
            {booking.bookingSno && <p className="text-sm text-white/60">ID: {booking.bookingSno}</p>}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="bg-green-500/20 rounded-2xl p-4 border-l-4 border-green-500">
              <p className="text-sm text-green-300 font-medium">📍 PICKUP LOCATION</p>
              <p className="text-lg font-bold mt-1">
                {/* pickup
                  ? `${pickup[0].toFixed(4)}, ${pickup[1].toFixed(4)}`
                  : (getDisplayLocations(booking).from || "N/A") */}

                {/* MODIFIED BY SANUPA */}
                {getDisplayLocations(booking).from || "N/A"}  
              </p>
              {distanceToPickup && (
                <p className="text-sm text-green-300 mt-1">{distanceToPickup ? Number(distanceToPickup).toFixed(2) : "..."} km away</p>
              )}
            </div>
            <div className="bg-red-500/20 rounded-2xl p-4 border-l-4 border-red-500">
              <p className="text-sm text-red-300 font-medium">🎯 DESTINATION</p>
              <p className="text-lg font-bold mt-1">
                {/* destination
                  ? `${destination[0].toFixed(4)}, ${destination[1].toFixed(4)}`
                  : (getDisplayLocations(booking).to || "N/A") */}

                  {/* MODIFIED BY SANUPA */}
                  {getDisplayLocations(booking).to || "N/A"}
              </p>
              {/* booking.totalDestence && (
                <p className="text-sm text-red-300 mt-1">Trip: {booking.totalDestence ? Number(booking.totalDestence).toFixed(2) : "..."} km</p>
              ) */}
              {/* MODIFIED BY SANUPA: The previous code is commented out and is available above */}
              {distanceToDestination && (
                <p className="text-sm text-red-300 mt-1">{distanceToDestination ? Number(distanceToDestination).toFixed(2) : "..."} km</p>
              )}
            </div>
          </div>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden" style={{ height: "300px", position: "relative", zIndex: "auto" }} onLoad={() => window.dispatchEvent(new Event('resize'))}>
          <style>{`
            .leaflet-container { z-index: 1 !important; }
            .leaflet-popup { z-index: 2 !important; }
            .leaflet-control { z-index: 2 !important; }
          `}</style>
          <MapContainer center={driverPos} zoom={14} style={{ height: "100%", width: "100%", zIndex: 1 }}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            {hasValidCoords && mapBounds.length >= 2 && <FitBounds bounds={mapBounds} />}
            <Marker position={driverPos} icon={getVehicleIcon(vehicleType)}>
              <Popup><strong>🚗 You are here</strong><br />{booking.vId}</Popup>
            </Marker>
            {hasValidCoords && pickup && (
              <Marker position={pickup} icon={pickupIcon}>
                <Popup><strong>📍 Pickup Location</strong><br />{distanceToPickup} km away</Popup>
              </Marker>
            )}
            {hasValidCoords && (tripStage === "trip_started" || tripStage === "completed") && destination && (
              <Marker position={destination} icon={destinationIcon}>
                <Popup><strong>🎯 Destination</strong><br />{booking.totalDestence ? Number(booking.totalDestence).toFixed(2) : "..."} km trip</Popup>
              </Marker>
            )}
            {hasValidCoords && showPickupRoute && routeToPickup.length > 0 && (
              <Polyline positions={routeToPickup} color="#3b82f6" weight={6} opacity={0.9} dashArray="10, 10" />
            )}
            {hasValidCoords && showDestRoute && routeToDestination.length > 0 && (
              <Polyline positions={routeToDestination} color="#ef4444" weight={6} opacity={0.9} />
            )}
          </MapContainer>
        </div>

        <div className="space-y-4">
          {tripStage === "accepted" && (
            <button onClick={handleStartToPickup} className="w-full bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white py-6 rounded-2xl font-bold text-2xl shadow-2xl transition transform hover:scale-[1.02] flex items-center justify-center gap-3">
              <span className="text-3xl">🚀</span> START - Head to Pickup
            </button>
          )}
          {tripStage === "heading_to_pickup" && (
            <div className="space-y-4">
              <CallEmployeeButton employeeName={booking.employeeName || "Employee"} employeePhone={employeePhoneNumber} showSMS={true} className="w-full" buttonSize="md" />
              <button onClick={handleArrivedAtPickup} className="w-full bg-gradient-to-r from-orange-500 to-amber-600 hover:from-orange-600 hover:to-amber-700 text-white py-6 rounded-2xl font-bold text-2xl shadow-2xl transition transform hover:scale-[1.02] flex items-center justify-center gap-3">
                <span className="text-3xl">📍</span> I'VE ARRIVED at Pickup
              </button>
            </div>
          )}
          {tripStage === "trip_started" && (
            <div className="space-y-4">
              <CallEmployeeButton employeeName={booking.employeeName || "Employee"} employeePhone={employeePhoneNumber} showSMS={true} className="w-full" buttonSize="md" />
              <button onClick={handleCompleteTrip} className="w-full bg-gradient-to-r from-purple-500 to-pink-600 hover:from-purple-600 hover:to-pink-700 text-white py-6 rounded-2xl font-bold text-2xl shadow-2xl transition transform hover:scale-[1.02] flex items-center justify-center gap-3">
                <span className="text-3xl">✅</span> COMPLETE TRIP
              </button>
            </div>
          )}
          {tripStage === "completed" && (
            <div className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-6 rounded-2xl font-bold text-2xl text-center shadow-2xl animate-pulse">
              <span className="text-3xl mr-2">🎉</span> TRIP COMPLETED SUCCESSFULLY!
            </div>
          )}
        </div>

        {tripStage !== "completed" && (
          <div className="bg-white/10 backdrop-blur rounded-2xl p-4 flex justify-around text-white text-center">
            <div>
              <p className="text-sm text-white/70">To Pickup</p>
              <p className="text-2xl font-bold">{distanceToPickup ? Number(distanceToPickup).toFixed(2) : "..."} km</p>
            </div>
            <div className="border-l border-white/20 pl-8">
              <p className="text-sm text-white/70">Trip Distance</p>
              {/* <p className="text-2xl font-bold">{booking.totalDestence ? Number(booking.totalDestence).toFixed(2) : "..."} km</p> */}
              {/* MODIFIED BY SANUPA - original code commented out and available above */}
              {<p className="text-2xl font-bold">{calculateDistance({ lat: pickup[0], lng: pickup[1] }, {lat: destination[0], lng: destination[1]})} km</p>}
            </div>
          </div>
        )}
      </main>

      <DriverFooter />

      {pickup && destination && (
        <HireAssistanceBubble
          tripStage={tripStage}
          pickupLocation={pickup ? { lat: pickup[0], lng: pickup[1] } : null}
          destinationLocation={destination ? { lat: destination[0], lng: destination[1] } : null}
          driverLocation={driverLocation ? { lat: driverLocation.latitude, lng: driverLocation.longitude } : null}
          onEmergency={handleOpenEmergency}
        />
      )}

      <EmergencyAlertModal isOpen={isEmergencyModalOpen} onClose={() => setIsEmergencyModalOpen(false)} onSend={handleSendEmergency} isSending={isSendingEmergency} />
    </div>
  );
};

export default DriverTrip;